/**
 * ============================================================
 * CẨM NANG XÂY CHƯƠNG TRÌNH BÁN HÀNG NHÀ THUỐC X2 DOANH SỐ (Bản 2.2)
 * Trung tâm công cụ thực chiến cho nhà thuốc
 * Căn cứ pháp lý: Nghị định 239/2026/NĐ-CP & Nghị định 81/2018/NĐ-CP
 * ============================================================
 */

/* ===================== THƯ VIỆN HỆ THỐNG ===================== */
export const CAMPAIGN_LIB = {
  khuVuc: [
    {id:"tp", ten:"Thành phố lớn"},
    {id:"tinh", ten:"TP tỉnh / thị xã"},
    {id:"thitran", ten:"Thị trấn"},
    {id:"nongthon", ten:"Nông thôn / xã"},
    {id:"kcn", ten:"Gần khu công nghiệp"}
  ],
  viTri: [
    {id:"duong", ten:"Mặt đường lớn"},
    {id:"dancu", ten:"Trong khu dân cư"},
    {id:"cho", ten:"Gần chợ"},
    {id:"benhvien", ten:"Gần bệnh viện, phòng khám"},
    {id:"truong", ten:"Gần trường học"}
  ],
  loaiHinh: [{id:"nhathuoc", ten:"Nhà thuốc"},{id:"quaythuoc", ten:"Quầy thuốc"}],
  tep: [
    {id:"caotuoi", ten:"Người cao tuổi"},
    {id:"mebe", ten:"Mẹ và bé"},
    {id:"dilam", ten:"Người đi làm"},
    {id:"congnhan", ten:"Công nhân"},
    {id:"hocsinh", ten:"Học sinh, sinh viên"},
    {id:"vanglai", ten:"Khách vãng lai"}
  ],
  kenh: [
    {id:"zalo", ten:"Zalo cá nhân / nhóm Zalo"},
    {id:"oa", ten:"Zalo OA / Facebook page"},
    {id:"phanmem", ten:"Phần mềm bán hàng có tích điểm"},
    {id:"chuaco", ten:"Chưa có kênh nào"}
  ],
  /* Hệ số chi phí thật của quà theo nguồn hàng */
  loaiQua: [
    {id:"hangtang", ten:"Quà hãng tặng", heSo:0, note:"hãng chịu chi phí"},
    {id:"cham", ten:"Hàng chậm bán", heSo:0.7, note:"vốn đang nằm chết"},
    {id:"thuong", ten:"Hàng bán bình thường", heSo:1, note:"tính đủ giá vốn"},
    {id:"thuoc", ten:"Thuốc không kê đơn", heSo:1, note:"chỉ dùng để xả, không làm quà"}
  ],
  /* Quà mua thêm khi kho không đủ — không có thuốc */
  quaMua: [
    {ten:"Khăn giấy ướt gói nhỏ", von:5000, le:9000},
    {ten:"Khẩu trang y tế gói 10 cái", von:6000, le:10000},
    {ten:"Nước muối sinh lý chai 500ml", von:6000, le:10000},
    {ten:"Băng dán cá nhân hộp 20 miếng", von:12000, le:20000},
    {ten:"Túi vải in tên quầy", von:12000, le:25000},
    {ten:"Hộp chia thuốc 7 ngày", von:15000, le:30000},
    {ten:"Nước rửa tay khô chai nhỏ", von:16000, le:30000},
    {ten:"Túi chườm nóng lạnh", von:22000, le:40000},
    {ten:"Bộ khăn mặt cotton", von:30000, le:55000},
    {ten:"Nhiệt kế điện tử", von:45000, le:85000},
    {ten:"Bình giữ nhiệt in logo quầy", von:65000, le:120000},
    {ten:"Ô gấp in logo quầy", von:75000, le:140000},
    {ten:"Cân sức khỏe điện tử", von:150000, le:270000},
    {ten:"Máy đo huyết áp bắp tay", von:450000, le:780000},
    {ten:"Nồi chiên không dầu", von:950000, le:1600000}
  ],
  /* Thư viện combo — không có thuốc kê đơn. thang: tháng phù hợp; tep: tệp phù hợp */
  combo: [
    {id:"cum", ten:"Combo cảm cúm 3 ngày", gia:160000, thang:[1,2,3,9,10,11,12], tep:["*"],
     mon:[["Hạ sốt, giảm đau (paracetamol)","OTC","chính"],["Vitamin C + kẽm","TPCN","hỗ trợ"],["Nước muối sinh lý / xịt mũi","VT","chăm sóc"],["Khẩu trang y tế","VT","chăm sóc"]],
     mo:"Anh/chị bị mấy ngày rồi ạ? Em lấy thuốc hạ sốt, kèm vitamin C kẽm cho nhanh hồi sức và nước muối rửa mũi, đủ dùng 3 ngày."},
    {id:"tieuhoa", ten:"Combo bụng êm mùa nóng", gia:180000, thang:[4,5,6,7,8], tep:["*"],
     mon:[["Men vi sinh","TPCN","chính"],["Oresol bù nước điện giải","OTC","hỗ trợ"],["Trà / thạch hỗ trợ tiêu hóa","TPCN","chăm sóc"]],
     mo:"Trời nóng dễ rối loạn tiêu hóa, nhà mình nên để sẵn men vi sinh và gói bù nước. Nếu đi ngoài nhiều lần, sốt hoặc có máu thì phải đi khám ngay ạ."},
    {id:"xuongkhop", ten:"Combo xương khớp người cao tuổi", gia:380000, thang:[1,2,3,10,11,12], tep:["caotuoi"],
     mon:[["Canxi + vitamin D3 K2","TPCN","chính"],["Glucosamine / sụn vi cá","TPCN","hỗ trợ"],["Túi chườm nóng","VT","chăm sóc"]],
     mo:"Cô chú hay mỏi gối khi trời lạnh, dùng thêm canxi D3 K2 và chườm nóng buổi tối sẽ dễ chịu hơn. Đau sưng nóng đỏ thì cô chú đi khám giúp con."},
    {id:"huyetap", ten:"Combo theo dõi huyết áp tại nhà", gia:890000, thang:["*"], tep:["caotuoi"],
     mon:[["Máy đo huyết áp bắp tay","TBYT","chính"],["Omega-3","TPCN","hỗ trợ"],["Sổ theo dõi huyết áp + hộp chia thuốc","VT","chăm sóc"]],
     mo:"Đo ở nhà sáng tối, ghi sổ, lần sau đi khám mang theo cho bác sĩ xem. Em hướng dẫn cách đo đúng ngay tại quầy."},
    {id:"mebe", ten:"Combo bé khỏe đề kháng", gia:360000, thang:["*"], tep:["mebe"],
     mon:[["Vitamin D3 K2 dạng nhỏ giọt","TPCN","chính"],["Men vi sinh trẻ em","TPCN","hỗ trợ"],["Nước muối sinh lý + dụng cụ hút mũi","VT","chăm sóc"]],
     mo:"Bé giao mùa hay sổ mũi, mẹ vệ sinh mũi hằng ngày và bổ sung D3 K2 theo đúng liều theo tuổi, em ghi liều lên hộp cho mẹ."},
    {id:"chongnang", ten:"Combo chống nắng, da khỏe", gia:420000, thang:[3,4,5,6,7,8,9], tep:["dilam","hocsinh","vanglai"],
     mon:[["Kem chống nắng","DMP","chính"],["Vitamin E / C dạng uống","TPCN","hỗ trợ"],["Xịt khoáng / sữa rửa mặt dịu nhẹ","DMP","chăm sóc"]],
     mo:"Đi nắng nhiều thì bôi lại kem sau 2–3 tiếng mới đủ, em tặng kèm hướng dẫn thứ tự dùng buổi sáng buổi tối."},
    {id:"mathi", ten:"Combo mùa thi tỉnh táo", gia:320000, thang:[4,5,6,11,12], tep:["hocsinh"],
     mon:[["Omega-3 / DHA","TPCN","chính"],["Vitamin nhóm B","TPCN","hỗ trợ"],["Nước nhỏ mắt nhân tạo","OTC","chăm sóc"]],
     mo:"Mùa thi học khuya, em gợi ý thêm vitamin nhóm B và nhỏ mắt nhân tạo, quan trọng nhất vẫn là ngủ đủ 7 tiếng."},
    {id:"dica", ten:"Combo đi ca hồi sức", gia:130000, thang:["*"], tep:["congnhan"],
     mon:[["Vitamin nhóm B / điện giải","TPCN","chính"],["Cao xoa / miếng dán giảm đau cơ","OTC","hỗ trợ"],["Băng dán cá nhân","VT","chăm sóc"]],
     mo:"Làm ca đứng nhiều dễ mỏi, uống bù điện giải và vitamin nhóm B, tối về xoa bóp nhẹ. Để sẵn băng dán trong tủ đồ."},
    {id:"ngungon", ten:"Combo ngủ ngon, bớt căng thẳng", gia:310000, thang:["*"], tep:["dilam","caotuoi"],
     mon:[["TPCN hỗ trợ giấc ngủ","TPCN","chính"],["Magie + B6","TPCN","hỗ trợ"],["Trà thảo mộc","TPCN","chăm sóc"]],
     mo:"Anh/chị khó ngủ bao lâu rồi ạ? Dưới 2 tuần thì mình thử cách này và hạn chế cà phê sau 2 giờ chiều; kéo dài hơn thì nên đi khám."},
    {id:"muaMua", ten:"Combo mùa mưa, phòng muỗi", gia:150000, thang:[6,7,8,9,10], tep:["*"],
     mon:[["Kem / xịt chống muỗi","DMP","chính"],["Oresol bù nước","OTC","hỗ trợ"],["Hạ sốt paracetamol","OTC","chăm sóc"]],
     mo:"Mùa mưa nhiều muỗi, nhà có trẻ nhỏ nên bôi chống muỗi. Sốt cao liên tục trên 2 ngày thì đi xét nghiệm, không tự ý dùng thuốc kéo dài."}
  ],
  /* Mẹo theo khu vực */
  tipKhuVuc: {
    tp:["Khách quen dùng voucher, tích điểm, nhắn Zalo — ưu tiên cơ chế số, quà gọn đẹp.","Truyền thông qua Zalo, Facebook page và Google Maps (cập nhật ảnh chương trình lên hồ sơ quầy)."],
    tinh:["Kết hợp quà hiện vật và voucher; khách phản hồi tốt với bốc thăm nếu giải nhất nhìn thấy được tại quầy.","Đăng bài lên các nhóm Facebook của phường/xã, nhờ khách quen chia sẻ."],
    thitran:["Quà hiện vật thiết thực (khẩu trang, nước muối, hộp chia thuốc) hiệu quả hơn voucher.","Bày quà và giải thưởng ngay mặt tiền; loa phát thanh, tờ rơi ngày chợ phiên."],
    nongthon:["Ưu tiên quà nhìn thấy được, cầm về được ngay. Voucher dễ bị quên.","Bốc thăm có giải nhất trưng bày tại quầy tạo tiếng đồn tốt nhất. Chạy vào ngày chợ phiên, nhờ trưởng thôn/chi hội thông báo."],
    kcn:["Chạy mạnh từ ngày nhận lương đến 5 ngày sau đó, và khung giờ tan ca.","Combo nhỏ giá dưới 150.000đ, thanh toán nhanh; nhắn nhóm Zalo của các tổ, xưởng."]
  },
  tipViTri: {
    duong:"Khách đi đường dừng nhanh: băng rôn chữ to, đọc được trong 3 giây, cơ chế một câu.",
    dancu:"Khách lặp lại nhiều: tích điểm và voucher quay lại đem hiệu quả cao nhất.",
    cho:"Chạy theo nhịp chợ: dồn quà và nhân lực vào buổi sáng, ngày chợ phiên.",
    benhvien:"Khách cầm đơn thuốc: không khuyến mại thuốc kê đơn, chỉ gợi ý sản phẩm chăm sóc sau khám.",
    truong:"Combo nhỏ cho học sinh và phụ huynh, chạy mạnh giờ tan học, mùa thi, đầu năm học."
  }
};
export const LIB = CAMPAIGN_LIB;

/* ===================== DANH MỤC CHƯƠNG TRÌNH (2 TẦNG) ===================== */
export const CAMPAIGN_PROG = [
  /* Tầng 1 — tổng quan */
  {id:"ngayhoi", tang:1, ten:"Ngày hội sức khỏe", mo:"Đo huyết áp, cân nặng miễn phí, tư vấn, dùng thử — kéo khách mới vào quầy", w:5, donbay:"Số khách"},
  {id:"khaitruong", tang:1, ten:"Khai trương", mo:"Hâm nóng trước, 3 ngày cao điểm, 30 ngày giữ khách", w:6, donbay:"Số khách"},
  {id:"trian", tang:1, ten:"Tri ân khách hàng", mo:"Sinh nhật quầy, cuối năm, Tết: quà cho khách thân thiết", w:4, donbay:"Số lần mua"},
  /* Tầng 2 — chương trình nhỏ */
  {id:"combo", tang:2, nhom:"Tăng giá trị mỗi hóa đơn", ten:"Combo bán kèm theo nhu cầu", mo:"Gói 3–4 sản phẩm theo bệnh và mùa", w:2, donbay:"Giá trị hóa đơn"},
  {id:"muanhieu", tang:2, nhom:"Tăng giá trị mỗi hóa đơn", ten:"Mua nhiều giảm giá (TPCN)", mo:"Mua 2 hộp giảm, mua 3 hộp giảm sâu hơn — đủ liệu trình", w:2, donbay:"Giá trị hóa đơn"},
  {id:"moc", tang:2, nhom:"Tăng giá trị mỗi hóa đơn", ten:"Mua đủ mốc tặng quà", mo:"Hóa đơn chạm mốc nhận quà, 3 mốc lũy tiến", w:2, donbay:"Giá trị hóa đơn"},
  {id:"dungthu", tang:2, nhom:"Kéo khách vào quầy", ten:"Dùng thử, hàng mẫu", mo:"Phát mẫu TPCN, mỹ phẩm kèm phiếu mua sản phẩm chính", w:1.5, donbay:"Số khách"},
  {id:"boctham", tang:2, nhom:"Kéo khách vào quầy", ten:"Bốc thăm / vòng quay may mắn", mo:"Hóa đơn đủ mức được một lượt, cơ cấu giải kiểm soát chi phí", w:2, donbay:"Số khách"},
  {id:"gioithieu", tang:2, nhom:"Kéo khách vào quầy", ten:"Giới thiệu người quen", mo:"Khách cũ giới thiệu, cả hai cùng nhận quà", w:1.5, donbay:"Số khách"},
  {id:"voucher", tang:2, nhom:"Kéo khách quay lại", ten:"Phiếu cho lần mua sau", mo:"Mua hôm nay nhận phiếu dùng lần tới", w:1.5, donbay:"Số lần mua"},
  {id:"tichdiem", tang:2, nhom:"Kéo khách quay lại", ten:"Tích điểm thành viên", mo:"Điểm đổi quà, hạng Bạc – Vàng, quà sinh nhật", w:1.5, donbay:"Số lần mua"},
  {id:"xahang", tang:2, nhom:"Giải phóng hàng tồn", ten:"Xả hàng chậm bán, cận hạn", mo:"Thu hồi vốn trước khi hàng thành hàng hủy", w:1, donbay:"Dòng tiền"}
];

export const PROG = CAMPAIGN_PROG;

export function progOf(id) {
  return CAMPAIGN_PROG.filter((p) => p.id === id)[0] || null;
}

/* ===================== 11 GIẢI PHÁP GIẢM CHI PHÍ ===================== */
export const HOTRO = [
  {id:"hang_ban", ten:"Hãng đồng hành: bàn tư vấn + mẫu dùng thử", ngan:"Hãng cử người, tặng mẫu", giam:{nhansu:0.5, mau:1}, cr:0.07, suKien:true,
   dk:"Quầy đang bán sản phẩm của hãng. Hãng tư vấn, cho dùng thử tại bàn; khách mua hàng tại quầy của bạn.",
   buoc:["Chọn 2–3 hãng có sản phẩm bạn đang bán chạy, ưu tiên TPCN tim mạch, xương khớp, tiêu hóa, mẹ bé.","Gửi đề nghị trước 3–4 tuần: ngày, lượt khách dự kiến, số lượt đo, đối tượng khách.","Thống nhất: hãng cử dược sĩ/chuyên gia, mẫu thử, standee; quầy lo mặt bằng, khách, thu tiền.","Chốt bằng tin nhắn hoặc biên bản ngắn: thời gian, số mẫu, nội dung tư vấn theo tài liệu đã được xác nhận.","Sau sự kiện gửi hãng số lượt tư vấn, số đơn, doanh số sản phẩm của hãng — để lần sau xin tiếp."],
   mau:"Chào anh/chị [tên], em là [tên], chủ [tên quầy] tại [địa chỉ]. Quầy em đang bán [sản phẩm của hãng], trung bình [x] hộp/tháng.\nNgày [dd/mm – dd/mm] quầy tổ chức {TEN_SK}, dự kiến đón khoảng {LUOT} lượt khách, trong đó khoảng {DO} lượt đo huyết áp miễn phí, chủ yếu {TEP}.\nEm mời hãng đồng hành:\n1. Cử dược sĩ/chuyên gia đứng bàn tư vấn\n2. Hỗ trợ khoảng {MAU} mẫu dùng thử\n3. Quà tặng nhỏ, standee, tờ rơi sản phẩm\nKhách được tư vấn và dùng thử tại bàn hãng, mua hàng tại quầy em. Sau sự kiện em gửi hãng báo cáo lượt tư vấn, số đơn và doanh số sản phẩm của hãng.\nAnh/chị cho em xin lịch trao đổi trong tuần này ạ."},
  {id:"hang_qua", ten:"Hãng / nhà phân phối tài trợ quà tặng", ngan:"Quà tài trợ", giam:{qua:0.5},
   dk:"Quà gắn thương hiệu hãng, hàng mẫu nhỏ, vật phẩm có logo.",
   buoc:["Hỏi sale của hãng và nhà phân phối về vật phẩm, hàng mẫu đang có sẵn.","Cam kết trưng bày sản phẩm hãng ở vị trí đẹp trong thời gian chương trình.","Ghi rõ nguồn quà trong sổ phát quà để báo cáo lại cho hãng."],
   mau:"Chào anh/chị, [tên quầy] chạy {TEN_SK} từ [ngày] đến [ngày], cần khoảng {SLQUA} phần quà nhỏ. Hãng mình có vật phẩm hoặc hàng mẫu hỗ trợ không ạ? Quầy sẽ trưng bày sản phẩm của hãng ở kệ đầu quầy suốt chương trình và gửi lại danh sách khách nhận quà."},
  {id:"hang_ck", ten:"Hãng hỗ trợ chiết khấu cho combo / mua nhiều", ngan:"Hãng chia phần giảm giá", giam:{giamHang:0.4},
   dk:"Áp dụng khi combo, mua nhiều dùng sản phẩm của hãng.",
   buoc:["Gửi hãng số bộ combo / số hộp dự kiến bán trong kỳ.","Đề nghị hãng bù 30–50% phần giảm giá bằng chiết khấu hoặc hàng tặng khi nhập.","Nhập hàng trước chương trình để lấy mức chiết khấu tốt."],
   mau:"Chào anh/chị, [tên quầy] chạy chương trình mua nhiều / combo cho [sản phẩm] từ [ngày] đến [ngày], dự kiến bán thêm khoảng [x] hộp. Quầy giảm cho khách [y]%. Hãng hỗ trợ giúp quầy khoảng một nửa phần giảm bằng chiết khấu nhập hàng được không ạ?"},
  {id:"hang_posm", ten:"Hãng tài trợ standee, tờ rơi, áo, băng rôn", ngan:"POSM của hãng", giam:{posm:0.7}, suKien:true,
   dk:"Dùng ấn phẩm hãng đã có, nội dung quảng cáo đã được cơ quan chức năng xác nhận.",
   buoc:["Xin hãng file hoặc ấn phẩm in sẵn (standee, tờ rơi, áo đồng phục, túi).","Chỉ tự in phần thông tin sự kiện của quầy."],
   mau:"Chào anh/chị, quầy tổ chức {TEN_SK} ngày [ngày]. Hãng hỗ trợ giúp quầy standee, tờ rơi sản phẩm và 2–3 áo đồng phục cho nhân viên được không ạ?"},
  {id:"phuong", ten:"Phát thanh phường/xã, xin treo phướn", ngan:"Loa phường", giam:{truyenthong:0.6}, traffic:0.1, suKien:true,
   dk:"Nội dung là hoạt động chăm sóc sức khỏe cộng đồng miễn phí, không quảng cáo thuốc. Băng rôn, phướn ngoài mặt tiền quầy phải được phường đồng ý.",
   buoc:["Gặp cán bộ văn hóa – thông tin hoặc trạm y tế phường trước 10–14 ngày, mang theo giấy chứng nhận đủ điều kiện kinh doanh dược.","Nộp đề nghị (mẫu bên dưới) kèm nội dung thông báo và mẫu băng rôn.","Xin phát 2–3 lần: trước 3 ngày, trước 1 ngày và sáng ngày sự kiện.","Treo phướn đúng vị trí, đúng thời gian được đồng ý; tháo ngay sau sự kiện."],
   mau:"Kính gửi: UBND phường/xã [tên] (bộ phận văn hóa – thông tin)\n[Tên quầy], địa chỉ [..], Giấy chứng nhận đủ điều kiện kinh doanh dược số [..], tổ chức hoạt động \"Ngày chăm sóc sức khỏe cộng đồng\" vào [giờ], ngày [..].\nNội dung: đo huyết áp, cân nặng, chỉ số BMI và hướng dẫn dùng thuốc an toàn miễn phí cho người dân, ưu tiên người cao tuổi.\nĐề nghị phường:\n1. Hỗ trợ thông báo trên hệ thống truyền thanh phường (nội dung đính kèm);\n2. Cho phép treo [số] băng rôn/phướn tại [vị trí] từ ngày [..] đến ngày [..].\nNội dung thông báo và băng rôn không quảng cáo thuốc. Trân trọng cảm ơn.\n\n— Nội dung phát thanh (khoảng 45 giây) —\nThông báo: Nhằm chăm sóc sức khỏe người dân, [tên quầy] tại [địa chỉ] tổ chức đo huyết áp, cân nặng và hướng dẫn dùng thuốc an toàn miễn phí từ [giờ] ngày [..]. Bà con, đặc biệt các cụ cao tuổi và người đang điều trị huyết áp, tiểu đường, mời đến tham gia. Nên mang theo sổ khám hoặc đơn thuốc đang dùng để được hướng dẫn kỹ hơn. Xin trân trọng thông báo."},
  {id:"hoi", ten:"Phối hợp hội người cao tuổi, hội phụ nữ, tổ dân phố", ngan:"Hội đoàn địa phương", giam:{truyenthong:0.2}, traffic:0.1, suKien:true,
   dk:"Dành khung giờ riêng cho hội viên, có ghế chờ, nước uống.",
   buoc:["Gặp chủ tịch hội / tổ trưởng trước 1–2 tuần, đưa thư mời in sẵn.","Dành khung giờ riêng (ví dụ 7h30–9h) để các cụ không phải chờ lâu.","Chụp ảnh hoạt động (khi được đồng ý) gửi lại hội — lần sau mời sẽ dễ hơn."],
   mau:"Kính gửi bác [tên], Chủ tịch Hội người cao tuổi [khu/tổ]. [Tên quầy] tổ chức đo huyết áp, cân nặng và hướng dẫn dùng thuốc miễn phí vào ngày [..]. Quầy xin dành riêng khung giờ [7h30–9h] cho các cụ trong hội, có ghế chờ và nước uống. Mong bác thông báo giúp hội viên. Cháu cảm ơn bác."},
  {id:"zalo_kv", ten:"Nhóm Zalo khu dân cư, chợ, trường, Facebook địa phương", ngan:"Nhóm cộng đồng", giam:{truyenthong:0.2},
   dk:"Nhờ admin nhóm đăng hoặc cho phép đăng, không spam.",
   buoc:["Liệt kê 5–10 nhóm Zalo/Facebook trong bán kính 2 km.","Nhắn admin xin phép, đăng 1 lần trước 3 ngày và 1 lần trước 1 ngày.","Nhờ khách quen chia sẻ bài vào nhóm của họ."],
   mau:"Nhà mình ơi, [tên quầy] ở [địa chỉ] tổ chức đo huyết áp, cân nặng miễn phí ngày [..] từ [giờ]. Ông bà, bố mẹ nhà mình ai cần kiểm tra thì ghé quầy nhé, có dược sĩ hướng dẫn dùng thuốc an toàn. Hỏi thêm: [SĐT quầy]."},
  {id:"sinhvien", ten:"Sinh viên thực tập dược / điều dưỡng", ngan:"Sinh viên hỗ trợ", giam:{nhansu:0.5}, suKien:true,
   dk:"Trường trung cấp, cao đẳng y dược cần nơi thực tập ngắn ngày; quầy xác nhận thực tập, hỗ trợ ăn trưa.",
   buoc:["Liên hệ khoa Dược / Điều dưỡng trường gần nhất trước 3 tuần.","Nhận 2–3 bạn, hướng dẫn 30 phút trước sự kiện: đo huyết áp, đón khách, ghi sổ.","Sinh viên không tư vấn thuốc — chuyển khách cho dược sĩ."],
   mau:"Kính gửi Khoa Dược trường [..]. [Tên quầy] tổ chức ngày chăm sóc sức khỏe cộng đồng ngày [..], xin nhận 2–3 sinh viên hỗ trợ đo huyết áp và hướng dẫn người dân. Quầy xác nhận thực tập và hỗ trợ ăn trưa. Trân trọng."},
  {id:"chung", ten:"Làm chung với cửa hàng lân cận", ngan:"Chia chi phí", giam:{posm:0.3, truyenthong:0.2},
   dk:"Cửa hàng mẹ bé, tạp hóa, phòng khám, spa gần quầy — không cạnh tranh trực tiếp.",
   buoc:["Rủ 1–2 cửa hàng cùng tuyến phố làm chung ngày hội.","Chia tiền băng rôn, loa, tờ rơi; mỗi bên có góc riêng.","Phát phiếu chéo: khách mua bên kia nhận phiếu đo sức khỏe bên mình."]},
  {id:"tuin", ten:"Tự thiết kế, in nhỏ, dùng lại vật phẩm", ngan:"In tiết kiệm", giam:{posm:0.3},
   dk:"Thiết kế bằng Canva, in A3/A4 thay băng rôn lớn; standee, khung ảnh dùng lại cho các lần sau.",
   buoc:["Làm 1 mẫu thiết kế dùng chung cho poster, tờ rơi, ảnh Zalo.","In tờ rơi A5 số lượng vừa đủ (≈ 3 lần số lượt khách dự kiến).","Làm phần nội dung thay đổi (ngày, giờ) bằng giấy dán để tái sử dụng."]},
  {id:"chophien", ten:"Chọn ngày trùng chợ phiên, ngày hội phường", ngan:"Đi theo đám đông", traffic:0.1, suKien:true,
   dk:"Khu vực thị trấn, nông thôn, gần chợ.",
   buoc:["Xem lịch chợ phiên, lễ hội, ngày tiêm chủng, ngày khám sức khỏe định kỳ của phường.","Đặt bàn đo ngay mặt tiền, nơi người đi chợ nhìn thấy."]}
];

export function hoTroOf(id) {
  return HOTRO.filter((h) => h.id === id)[0] || null;
}

export const TUVAN = [
  { id: "quay", ten: "Dược sĩ của quầy" },
  { id: "hang", ten: "Dược sĩ của hãng" },
  { id: "chuyengia", ten: "Chuyên gia / bác sĩ phối hợp" }
];

/* ===================== TIỆN ÍCH DÙNG CHUNG ===================== */
export function isoDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function parseISO(s) {
  if (!s) return new Date();
  const p = String(s).split("-").map(Number);
  return new Date(p[0], (p[1] || 1) - 1, p[2] || 1);
}

export function addDays(d, n) {
  const r = new Date(d.getTime());
  r.setDate(r.getDate() + n);
  return r;
}

export function dmy(d) {
  return String(d.getDate()).padStart(2, "0") + "/" + String(d.getMonth() + 1).padStart(2, "0");
}

export function dmyy(d) {
  return dmy(d) + "/" + d.getFullYear();
}

export function num(v) {
  if (typeof v === "number") return isNaN(v) ? 0 : v;
  if (!v) return 0;
  const n = parseFloat(String(v).replace(/,/g, "."));
  return isNaN(n) ? 0 : n;
}

export function vnd(n) {
  return Math.round(num(n)).toLocaleString("vi-VN") + "đ";
}

export function tr(n) {
  const v = num(n);
  if (Math.abs(v) >= 1e6) {
    const s = (v / 1e6).toFixed(1).replace(/\.0$/, "").replace(".", ",");
    return s + " tr";
  }
  if (Math.abs(v) >= 1e3) {
    const s = (v / 1e3).toFixed(0);
    return s + "k";
  }
  return vnd(v);
}

export function kk(n) {
  return Math.round(num(n) / 1000) + "k";
}

export function pct(x, d = 1) {
  return (num(x) * 100).toFixed(d).replace(".", ",") + "%";
}

export function esc(s) {
  return String(s || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

export function clamp(v, a, b) {
  return Math.max(a, Math.min(b, v));
}

export function niceUp(x) {
  if (x <= 50000) return Math.ceil(x / 10000) * 10000;
  if (x <= 200000) return Math.ceil(x / 20000) * 20000;
  if (x <= 500000) return Math.ceil(x / 50000) * 50000;
  return Math.ceil(x / 100000) * 100000;
}

export function nice5k(x) {
  return Math.max(5000, Math.round(x / 5000) * 5000);
}


export function camTuTen(ten) {
  const s = String(ten || "").toLowerCase();
  if (/kê đơn|rx|theo đơn/i.test(s)) return "rx";
  if (/sữa|dinh dưỡng/i.test(s) && /dưới 24|24 tháng|<24/i.test(s)) return "sua";
  return "";
}

export function camOf(n) {
  return n.cam || camTuTen(n.ten);
}

export function hsdThang(q) {
  const h = num(q?.hsd);
  return h <= 0 ? 999 : h;
}

export function quaTag(q) {
  if (!q?.ten) return '<span class="tag">—</span>';
  const h = hsdThang(q);
  if (h < 1) return '<span class="tag bad">Dưới 1 tháng: không dùng, trả NCC hoặc hủy</span>';
  if (q.loai === "thuoc") return h <= 6 ? '<span class="tag warn">Xả hàng (không làm quà)</span>' : '<span class="tag">Không làm quà</span>';
  if (h <= 3) return '<span class="tag warn">Quà ngắn ngày + xả hàng</span>';
  if (q.loai === "cham" || h <= 6) return '<span class="tag gift">Làm quà + xả hàng</span>';
  return '<span class="tag gift">Làm quà</span>';
}

/* ===================== DỮ LIỆU MẪU & KHỞI TẠO ===================== */
export function mauState() {
  const d = new Date();
  d.setDate(d.getDate() + 24);
  return {
    khuVuc: "thitran",
    viTri: "cho",
    loaiHinh: "quaythuoc",
    dsNgay: 8,
    donGia: 95,
    soNgay: 14,
    batDau: isoDate(d),
    tep: ["caotuoi", "mebe"],
    kenh: ["zalo"],
    nhom: [
      { ten: "Thuốc không kê đơn", tt: 32, bien: 18, cam: "" },
      { ten: "Thuốc kê đơn", tt: 24, bien: 12, cam: "rx" },
      { ten: "TPCN, vitamin", tt: 20, bien: 35, cam: "" },
      { ten: "Sữa trẻ dưới 24 tháng", tt: 6, bien: 9, cam: "sua" },
      { ten: "Dược mỹ phẩm, chăm sóc cá nhân", tt: 10, bien: 30, cam: "" },
      { ten: "Thiết bị, vật tư y tế", tt: 8, bien: 25, cam: "" }
    ],
    qua: [
      { ten: "Kẹo ngậm thảo dược (quà hãng)", loai: "hangtang", von: 15000, le: 25000, sl: 60, hsd: 10 },
      { ten: "Khẩu trang y tế hộp 50 cái", loai: "thuong", von: 25000, le: 40000, sl: 40, hsd: 24 },
      { ten: "Nước muối sinh lý 500ml", loai: "thuong", von: 6000, le: 10000, sl: 120, hsd: 18 },
      { ten: "Vitamin C sủi tuýp 20 viên", loai: "cham", von: 38000, le: 60000, sl: 25, hsd: 4 },
      { ten: "Túi vải in tên quầy", loai: "thuong", von: 12000, le: 25000, sl: 100, hsd: 0 },
      { ten: "Siro ho thảo dược 100ml", loai: "thuoc", von: 42000, le: 65000, sl: 18, hsd: 2 }
    ],
    tongQuan: "ngayhoi",
    ct: ["combo", "muanhieu", "voucher"],
    pheu: { doSK: "co", nguoiDo: 2, ngaySK: 2, tuVan: "quay", mau: 100, giaMau: 12, giaTPCN: 350 },
    hoTro: ["phuong", "zalo_kv"],
    mucTieu: 30,
    nganSach: ""
  };
}

export function trongState() {
  const d = new Date();
  d.setDate(d.getDate() + 21);
  return {
    khuVuc: "thitran",
    viTri: "duong",
    loaiHinh: "quaythuoc",
    dsNgay: "",
    donGia: "",
    soNgay: 14,
    batDau: isoDate(d),
    tep: ["caotuoi"],
    kenh: ["zalo"],
    nhom: [
      { ten: "Thuốc không kê đơn", tt: 40, bien: 18, cam: "" },
      { ten: "Thuốc kê đơn", tt: 30, bien: 12, cam: "rx" },
      { ten: "TPCN, vitamin", tt: 15, bien: 30, cam: "" },
      { ten: "Sữa trẻ dưới 24 tháng", tt: 5, bien: 10, cam: "sua" },
      { ten: "Dược mỹ phẩm, cá nhân", tt: 5, bien: 25, cam: "" },
      { ten: "Vật tư, thiết bị y tế", tt: 5, bien: 20, cam: "" }
    ],
    qua: [
      { ten: "", loai: "thuong", von: "", le: "", sl: "", hsd: "" }
    ],
    tongQuan: "",
    ct: ["combo", "voucher"],
    pheu: { doSK: "khong", nguoiDo: 2, ngaySK: 2, tuVan: "quay", mau: 50, giaMau: 15, giaTPCN: 280 },
    hoTro: [],
    mucTieu: 20,
    nganSach: ""
  };
}

// Chuẩn hóa bản nháp đọc từ localStorage (SRS-IN-06c, SRS-IN-06e; HT-06 F-09):
// - trường thiếu lấy theo trongState() để lapKeHoach không gặp undefined; mảng chọn nhiều thiếu thì để rỗng
// - bỏ id chương trình / hỗ trợ không còn trong danh mục; tongQuan chỉ nhận chương trình tầng 1
// Trả null nếu bản nháp không dùng được (thiếu nhom / qua) để trang nạp dữ liệu mẫu.
export function chuanHoaBanNhap(raw) {
  if (!raw || typeof raw !== "object" || !Array.isArray(raw.nhom) || !Array.isArray(raw.qua)) return null;
  const base = trongState();
  const arr = (v) => (Array.isArray(v) ? v : []);
  const tang1 = CAMPAIGN_PROG.filter((p) => p.tang === 1).map((p) => p.id);
  const tang2 = CAMPAIGN_PROG.filter((p) => p.tang === 2).map((p) => p.id);
  const hoTroIds = HOTRO.map((h) => h.id);
  return {
    ...base,
    ...raw,
    tep: arr(raw.tep),
    kenh: arr(raw.kenh),
    ct: arr(raw.ct).filter((id) => tang2.indexOf(id) >= 0),
    hoTro: arr(raw.hoTro).filter((id) => hoTroIds.indexOf(id) >= 0),
    tongQuan: tang1.indexOf(raw.tongQuan) >= 0 ? raw.tongQuan : "",
    pheu: { ...base.pheu, ...(raw.pheu && typeof raw.pheu === "object" ? raw.pheu : {}) }
  };
}

export function goiY(S) {
  if (!S) return {};
  const r = {};
  const m = tinhNhom(S.nhom || []);
  const A = num(S.donGia) * 1000;
  const has = (t) => (S.tep || []).indexOf(t) >= 0;

  if (A > 0 && A < 120000) r.moc = "Giá trị hóa đơn đang thấp, mốc quà kéo lên nhanh nhất";
  if (m.bienKM >= 0.22) r.combo = "Nhóm được khuyến mại có biên tốt, combo giữ được lãi";
  if (S.viTri === "dancu" || has("caotuoi") || has("mebe")) r.tichdiem = "Khách quay lại thường xuyên";
  if (S.khuVuc === "nongthon" || S.khuVuc === "thitran") r.boctham = "Khu vực phản hồi tốt với giải thưởng nhìn thấy được";
  if ((S.kenh || []).indexOf("zalo") >= 0 || (S.kenh || []).indexOf("oa") >= 0) r.voucher = "Có kênh Zalo để nhắc khách dùng phiếu";

  const ton = (S.qua || []).some((q) => {
    const h = hsdThang(q);
    return q.ten && h >= 1 && (h <= 6 || q.loai === "cham");
  });
  if (ton) r.xahang = "Đang có hàng chậm bán hoặc cận hạn";
  if (S.khuVuc === "kcn") r.gioithieu = "Công nhân hay rủ nhau đi mua theo nhóm";
  if (has("caotuoi") || S.khuVuc === "thitran" || S.khuVuc === "nongthon") r.ngayhoi = "Đo sức khỏe miễn phí kéo người cao tuổi và khách mới rất tốt";

  const tpcn = (S.nhom || []).filter((n) => /tpcn|vitamin/i.test(n.ten))[0];
  if (tpcn && num(tpcn.bien) >= 25) {
    r.muanhieu = "TPCN biên tốt, mua đủ liệu trình vẫn giữ lãi";
    r.dungthu = "Dùng thử mở đường cho khách mới mua TPCN";
  }

  return r;
}

/* ===================== ĐỘNG CƠ TÍNH TOÁN ===================== */
export function tinhNhom(nhomList = []) {
  let tong = 0;
  let lg = 0;
  let ttKM = 0;
  let lgKM = 0;
  let ttRx = 0;

  nhomList.forEach((n) => {
    const t = num(n.tt);
    const b = num(n.bien) / 100;
    tong += t;
    lg += t * b;
    const cm = camOf(n);
    if (cm) {
      if (cm === "rx") ttRx += t;
    } else {
      ttKM += t;
      lgKM += t * b;
    }
  });

  return {
    tong,
    bienTB: tong > 0 ? lg / tong : 0,
    tyKM: tong > 0 ? ttKM / tong : 0,
    bienKM: ttKM > 0 ? lgKM / ttKM : 0,
    tyRx: tong > 0 ? ttRx / tong : 0
  };
}

export function bienLoai(loai, m, S) {
  const key = {
    OTC: /không kê|otc/i,
    TPCN: /tpcn|vitamin|thực phẩm/i,
    DMP: /mỹ phẩm|chăm sóc/i,
    VT: /vật tư|thiết bị/i,
    TBYT: /thiết bị|vật tư/i
  }[loai];

  const nhomList = S?.nhom || [];
  for (let i = 0; i < nhomList.length; i++) {
    const n = nhomList[i];
    if (!camOf(n) && key && key.test(n.ten) && num(n.bien) > 0) {
      return num(n.bien) / 100;
    }
  }
  return m.bienKM;
}

export function taoKho(T, S) {
  const canHsd = T / 30 + 1;
  const quaList = S?.qua || [];
  return quaList.map((q, i) => {
    const h = hsdThang(q);
    const loai = CAMPAIGN_LIB.loaiQua.filter((l) => l.id === q.loai)[0] || CAMPAIGN_LIB.loaiQua[2];
    let heSo = loai.heSo;
    if (q.loai !== "hangtang" && h <= 3) heSo = Math.min(heSo, 0.4);
    return {
      idx: i,
      ten: q.ten,
      loai: q.loai,
      von: num(q.von),
      le: num(q.le) || num(q.von) * 1.5,
      sl: Math.floor(num(q.sl)),
      con: Math.floor(num(q.sl)),
      hsd: h,
      heSo,
      laQua: !!q.ten && q.loai !== "thuoc" && h >= canHsd && h >= 1,
      laXa: !!q.ten && h >= 1 && (h <= 6 || q.loai === "cham"),
      huy: !!q.ten && h < 1
    };
  });
}

export function chonQua(kho, target, need, capCost, tag) {
  need = Math.max(0, Math.round(need));
  let best = null;
  let bs = 1e9;

  kho.forEach((k) => {
    if (!k.laQua || k.con <= 0 || k.le <= 0) return;
    const real = k.von * k.heSo;
    if (capCost > 0 && real > capCost * 1.25) return;
    const r = k.le / target;
    if (r < 0.45 || r > 2.2) return;
    const sc = Math.abs(Math.log(r)) - (k.heSo < 1 ? 0.25 : 0) - Math.min(k.con / Math.max(need, 1), 1) * 0.15;
    if (sc < bs) {
      bs = sc;
      best = k;
    }
  });

  const lines = [];
  if (best) {
    const q = Math.min(need, best.con);
    best.con -= q;
    lines.push({
      ten: best.ten,
      sl: q,
      le: best.le,
      von: best.von,
      real: best.von * best.heSo,
      nguon: "kho",
      heSo: best.heSo,
      tag
    });
    need -= q;
  }

  if (need > 0 || !best) {
    let g = null;
    let gs = 1e9;
    CAMPAIGN_LIB.quaMua.forEach((x) => {
      if (capCost > 0 && x.von > capCost * 1.25) return;
      const s = Math.abs(Math.log(x.le / target));
      if (s < gs) {
        gs = s;
        g = x;
      }
    });
    if (!g) g = CAMPAIGN_LIB.quaMua[0];
    lines.push({
      ten: g.ten,
      sl: need,
      le: g.le,
      von: g.von,
      real: g.von,
      nguon: "mua",
      heSo: 1,
      tag,
      thieu: !!best
    });
  }
  return lines;
}

export function sumCost(lines) {
  return lines.reduce((a, l) => a + l.sl * l.real, 0);
}

export function tenQua(lines) {
  return lines.map((l) => l.ten).join(" hoặc ");
}

export function bienTPCNOf(m, S) {
  const nhomList = S?.nhom || [];
  const t = nhomList.filter((n) => !camOf(n) && /tpcn|vitamin|thực phẩm/i.test(n.ten) && num(n.bien) > 0)[0];
  return t ? num(t.bien) / 100 : Math.max(m.bienKM, 0.3);
}

export function giamCua(set = [], nhom) {
  let r = 0;
  set.forEach((id) => {
    const h = hoTroOf(id);
    if (h && h.giam && h.giam[nhom]) r += h.giam[nhom];
  });
  return Math.min(0.9, r);
}

export function dongChiPhi(p) {
  if (p.cpLines) return p.cpLines;
  const qua = sumCost((p.qua || []).filter((l) => l.sl > 0));
  const giam = Math.max(0, p.chiPhiGoc0 - qua);
  const L = [];
  if (qua > 0) L.push({ nhom: "qua", ten: "Quà tặng (giá vốn)", tien: qua });
  if (giam > 0) {
    L.push({
      nhom: p.id === "combo" || p.id === "muanhieu" ? "giamHang" : "giam",
      ten: p.id === "xahang" ? "Bán dưới giá vốn" : p.id === "combo" || p.id === "muanhieu" ? "Giảm giá sản phẩm" : "Giảm giá, phiếu, điểm",
      tien: giam
    });
  }
  return L;
}

export function chiPhiVoi(plans, set = []) {
  return plans.reduce((a, p) => {
    return a + dongChiPhi(p).reduce((b, l) => {
      return b + l.tien * (1 - giamCua(set, l.nhom));
    }, 0);
  }, 0);
}

export function suKien(c, loai) {
  const pf = c.pf || {};
  const doOn = pf.doSK === "co";
  const visits = c.N0 * c.h * c.evDays;
  const nguoi = Math.max(1, Math.round(num(pf.nguoiDo) || 1));
  const cap = nguoi * 8 * 12 * c.evDays;
  const muonDo = Math.round(visits * (loai === "trian" ? 0.3 : 0.4));
  const luotDo = doOn ? Math.min(cap, muonDo) : 0;
  const cr = c.cr;
  const crNoDo = { quay: 0.03, hang: 0.05, chuyengia: 0.07 }[pf.tuVan] || 0.03;
  const donTPCN = doOn ? Math.round(luotDo * cr) : Math.round(visits * crNoDo);
  const dsTPCN = donTPCN * c.giaTPCN * 0.8;
  const dsExtra = c.extra * c.A * 0.7;
  const khMoi = Math.round(c.extra * 0.8);
  const ds90 = khMoi * 0.4 * 2 * c.A;
  const mauN = !c.has("dungthu") ? Math.round(num(pf.mau) || 0) : 0;
  const dungMau = Math.round(mauN * 0.12);
  const ds30 = dungMau * c.giaTPCN;
  const quaDo = doOn && loai !== "khaitruong" ? chonQua(c.kho, 10000, luotDo, 8000, "Quà cho người đo sức khỏe") : [];

  const L = [];
  L.push({
    nhom: "posm",
    ten: "Băng rôn, phướn, standee",
    tien: { ngayhoi: 900000, khaitruong: 1800000, trian: 600000 }[loai] || 600000
  });
  L.push({
    nhom: "truyenthong",
    ten: "Tờ rơi, loa, đăng bài",
    tien: Math.round(visits * 2) * 400 + (loai === "khaitruong" ? 500000 : 300000)
  });
  if (doOn) {
    L.push({
      nhom: "nhansu",
      ten: `Thêm người trực đo, tư vấn (${nguoi} người × ${c.evDays} ngày)`,
      tien: nguoi * c.evDays * 300000
    });
    L.push({ nhom: "vattu", ten: "Vật tư đo, sổ theo dõi", tien: luotDo * 2000 });
    if (sumCost(quaDo) > 0) L.push({ nhom: "qua", ten: "Quà cho người đo sức khỏe", tien: sumCost(quaDo) });
  }
  if (mauN > 0) {
    L.push({ nhom: "mau", ten: `Mẫu dùng thử (${mauN} mẫu)`, tien: mauN * (num(pf.giaMau) || 0) * 1000 });
  }

  return {
    visits, cap, muonDo, luotDo, cr, donTPCN, dsTPCN, dsExtra,
    khMoi, ds90, mauN, dungMau, ds30, quaDo, lines: L, nguoi, doOn
  };
}

export const BANG_TU_VAN = {
  head: ["Chỉ số / tình huống", "Dược sĩ nói gì", "Gợi ý tại quầy"],
  rows: [
    ["Huyết áp từ 180/110 trở lên", "Khuyên đi khám ngay, không trì hoãn", "Không bán thêm sản phẩm"],
    ["Huyết áp 140/90 trở lên, chưa điều trị", "Khuyên đi khám trong tuần để bác sĩ chẩn đoán", "Sổ theo dõi, máy đo tại nhà nếu khách cần"],
    ["Đang điều trị, chỉ số chưa ổn", "Nhắc uống thuốc đúng giờ, mang sổ đi tái khám; không tự đổi thuốc", "Hộp chia thuốc, máy đo tại nhà"],
    ["Huyết áp 120–139 / 80–89", "Giảm muối, vận động 30 phút mỗi ngày, đo lại sau 1 tháng", "TPCN hỗ trợ tim mạch (omega-3…) — không thay thuốc"],
    ["BMI từ 23 trở lên", "Ăn nhiều rau, giảm đồ ngọt, vận động đều", "Chất xơ, men vi sinh (TPCN)"],
    ["Người cao tuổi hay mỏi gối, chuột rút", "Hỏi thêm triệu chứng; đau sưng nóng đỏ thì đi khám", "Canxi D3 K2, glucosamine (TPCN), túi chườm"],
    ["Đang dùng từ 3 loại thuốc trở lên", "Rà giờ uống, nhắc tương tác thường gặp", "Hộp chia thuốc 7 ngày"]
  ]
};

export const BANG_TU_VAN_KHONG_DO = {
  head: ["Tình huống tư vấn", "Dược sĩ nói gì", "Gợi ý tại quầy"],
  rows: [
    ["Khách có đơn thuốc mạn tính (HA, tiểu đường)", "Nhắc uống đúng giờ, tái khám đúng hẹn; kiểm tra tương tác thuốc", "Hộp chia thuốc 7 ngày, máy đo huyết áp tại nhà nếu chưa có"],
    ["Khách cao tuổi mệt mỏi, mất ngủ, hay quên", "Hỏi thói quen sinh hoạt; tư vấn dưỡng tâm, an thần, dinh dưỡng", "Ginkgo biloba, canxi, vitamin tổng hợp người cao tuổi (TPCN)"],
    ["Khách hay đau nhức xương khớp, thoái hóa", "Hướng dẫn vận động nhẹ, chườm ấm; giải thích TPCN hỗ trợ bảo vệ khớp", "Glucosamine, Canxi D3 K2, collagen type 2"],
    ["Khách bị đầy hơi, rối loạn tiêu hóa kéo dài", "Uống đủ nước, ăn chín uống sôi, bổ sung lợi khuẩn đường ruột", "Men vi sinh, men tiêu hóa, chất xơ hòa tan"],
    ["Khách đang dùng từ 3 loại thuốc trở lên", "Rà soát kỹ khoảng cách uống giữa các thuốc, tránh tương kỵ", "Sổ tay ghi nhớ lịch uống thuốc"]
  ]
};

export function DK_SU_KIEN(c) {
  const A = [
    "Hoạt động mang tính chất ngày hội sức khỏe cộng đồng: đo huyết áp, cân nặng, hướng dẫn dùng thuốc an toàn miễn phí.",
    "Không tổ chức khám bệnh, chẩn đoán, kê đơn hay xét nghiệm xâm lấn tại quầy khi không phối hợp cơ sở KCB.",
    "Quà tặng người tham gia đo sức khỏe là vật phẩm chăm sóc sức khỏe thông thường, không dùng thuốc làm quà.",
    "Ấn phẩm quảng cáo TPCN của hãng phát trong ngày hội phải là bản đã được cơ quan có thẩm quyền xác nhận nội dung.",
    "Băng rôn, phướn, thông báo loa phường chỉ mang nội dung hướng dẫn sức khỏe và thông tin hoạt động miễn phí, không quảng cáo thuốc."
  ];
  if (c.pf?.tuVan === "chuyengia") {
    A.push("Tư vấn có bác sĩ tham gia phải do phòng khám / bệnh viện có giấy phép phối hợp thực hiện theo hợp đồng chuyên môn.");
  }
  if ((c.S?.hoTro || []).indexOf("hang_ban") >= 0) {
    A.push("Bàn tư vấn của hãng chỉ giới thiệu sản phẩm và cho trải nghiệm; khách mua thanh toán tại quầy thuốc.");
  }
  return A;
}

export function ganSuKien(c, p, loai, dsRieng = 0, fSan = null) {
  const f = fSan || suKien(c, loai);
  p.pheu = f;
  const quaLines = (p.qua || []).filter((l) => l.sl > 0);
  p.qua = quaLines.concat(f.quaDo);
  const L = f.lines.slice();
  if (sumCost(quaLines) > 0) L.push({ nhom: "qua", ten: "Quà của chương trình", tien: sumCost(quaLines) });
  if (p.cpKhac) L.push(p.cpKhac);
  p.cpLines = L;
  p.chiPhi = L.reduce((a, l) => a + l.tien, 0);
  p.dsTang = f.dsExtra + f.dsTPCN + (dsRieng || 0);
  p.laiGop = (f.dsExtra + (dsRieng || 0)) * c.bKM + f.dsTPCN * c.bienTPCN;
  p.ds30 = f.ds30;
  p.lai30 = f.ds30 * c.bienTPCN;
  p.ds90 = f.ds90;
  p.lai90 = f.ds90 * c.bKM;
  p.bangTuVan = f.doOn ? BANG_TU_VAN : BANG_TU_VAN_KHONG_DO;
  p.dieuKien = (p.dieuKien || []).concat(DK_SU_KIEN(c));
  return p;
}

/* ===================== CÁC BỘ SINH CHƯƠNG TRÌNH ===================== */
export const GEN = {};

export const LOAI_TRU_KM = "Không tính thuốc kê đơn và sữa cho trẻ dưới 24 tháng vào giá trị hóa đơn.";

GEN.moc = function(c) {
  const S = c.S || mauState();
  var f=[2,3.5,6], p=[0.15,0.06,0.02], gv=[0.05,0.06,0.07], cc=[0.12,0.13,0.15];
  if(c.has("khaitruong")) p=[0.20,0.08,0.03];
  var moc=[], last=0;
  f.forEach(function(x){ var v=niceUp(c.A*x); if(v<=last) v=niceUp(last*1.5); moc.push(v); last=v; });
  var rows=[], allQua=[];
  moc.forEach(function(v,i){
    var cnt=Math.round(c.N*c.T*p[i]*c.m.tyKM/0.7);
    var lines=chonQua(c.kho, v*gv[i], cnt, v*c.bKM*cc[i], "Mốc "+(i+1));
    allQua=allQua.concat(lines);
    rows.push({moc:v, qua:tenQua(lines), le:lines[0].le, real:sumCost(lines)/Math.max(cnt,1), cnt:cnt, cost:sumCost(lines), lines:lines});
  });
  var chiPhi=rows.reduce(function(a,r){return a+r.cost;},0);
  var gan=niceUp(c.A*1.2);
  return {
    muc:"Kéo giá trị trung bình mỗi hóa đơn từ "+vnd(c.A)+" lên khoảng "+vnd(c.A*1.1)+".",
    doiTuong:"Mọi khách mua lẻ tại quầy.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to),
    bang:{head:["Mốc","Hóa đơn từ","Quà tặng","Giá trị quà","Chi phí thật / lượt","Dự kiến lượt","Chi phí"],
      rows:rows.map(function(r,i){return ["Mốc&nbsp;"+(i+1), vnd(r.moc), '<span class="giftcell">'+esc(r.qua)+'</span>', vnd(r.le), vnd(r.real), r.cnt.toLocaleString("vi-VN"), vnd(r.cost)];})},
    dieuKien:[LOAI_TRU_KM,"Mỗi hóa đơn nhận quà của mốc cao nhất đạt được, không cộng dồn các mốc.","Không gộp nhiều hóa đơn, không tách hóa đơn.","Quà có hạn, hết quà quầy đổi quà tương đương và báo trước trên bảng thể lệ."],
    qua:allQua, moc:rows,
    kichBan:[
      {tinh:"Hóa đơn gần chạm mốc (thiếu dưới 30.000đ)", noi:"Hóa đơn của anh/chị đang "+vnd(moc[0]-20000)+", thêm khoảng 20.000đ nữa là nhận được "+rows[0].qua.toLowerCase()+". Nhà mình có cần thêm nước muối, khẩu trang hay khăn giấy ướt không ạ?"},
      {tinh:"Khách hỏi chương trình", noi:"Tháng này quầy tặng quà theo hóa đơn: từ "+kk(moc[0])+" tặng "+rows[0].qua.toLowerCase()+", từ "+kk(moc[1])+" tặng "+rows[1].qua.toLowerCase()+", từ "+kk(moc[2])+" tặng "+rows[2].qua.toLowerCase()+"."},
      {tinh:"Nguyên tắc", noi:"Chỉ gợi ý thêm sản phẩm chăm sóc, vật tư, TPCN phù hợp nhu cầu. Không gợi ý mua thêm thuốc để đủ mốc."}
    ],
    poster:{hl:"Mua từ "+kk(moc[0])+" — nhận quà ngay", sub:kk(moc[0])+": "+rows[0].qua+" · "+kk(moc[1])+": "+rows[1].qua+" · "+kk(moc[2])+": "+rows[2].qua},
    zalo:"[Tên quầy] gửi anh/chị chương trình tặng quà từ "+dmy(c.from)+" đến "+dmy(c.to)+":\n• Hóa đơn từ "+vnd(moc[0])+": tặng "+rows[0].qua+"\n• Từ "+vnd(moc[1])+": tặng "+rows[1].qua+"\n• Từ "+vnd(moc[2])+": tặng "+rows[2].qua+"\nQuà có hạn, anh/chị ghé sớm giúp quầy nhé. Hotline: [SĐT quầy]",
    kpi:[["Giá trị trung bình hóa đơn", "≥ "+vnd(c.A*1.1)],["Tỷ lệ hóa đơn đạt mốc", "≥ "+pct(p[0]+p[1]+p[2],0)],["Quà còn lại cuối kỳ", "≤ 15% số chuẩn bị"]],
    chuanBi:["Soạn quà theo 3 kệ riêng, dán nhãn Mốc 1/2/3.","In bảng mốc khổ A3 dán tại quầy thu ngân và cửa.","Cài ghi chú mốc trên phần mềm bán hàng để nhân viên nhìn thấy khi tính tiền."],
    chiPhi:chiPhi, dsTang:c.DSky*c.m.tyKM*0.12,
    moTaNgan:"Mốc "+moc.map(kk).join(" / ")
  };
};

GEN.combo = function(c) {
  const S = c.S || mauState();
  var list=LIB.combo.map(function(x){
    var s=0;
    if(x.thang[0]==="*") s+=1; else if(x.thang.indexOf(c.month)>=0) s+=2.5;
    if(x.tep[0]==="*") s+=1; else if(x.tep.some(function(t){return S.tep.indexOf(t)>=0;})) s+=3;
    if(S.viTri==="truong" && x.id==="mathi") s+=1.5;
    if(S.khuVuc==="kcn" && x.id==="dica") s+=2;
    if((S.khuVuc==="nongthon"||S.khuVuc==="thitran") && x.gia>600000) s-=1.5;
    return {x:x,s:s};
  }).sort(function(a,b){return b.s-a.s;}).slice(0,3).map(function(o){return o.x;});
  var share=[0.03,0.02,0.015], rows=[], chiPhi=0, ds=0, kb=[];
  list.forEach(function(x,i){
    var w=[0.4,0.3,0.2,0.1].slice(0,x.mon.length), sw=w.reduce(function(a,b){return a+b;},0);
    var bien=x.mon.reduce(function(a,mm,j){return a+bienLoai(mm[1],c.m)*w[j]/sw;},0);
    var d=clamp(Math.round(bien*0.3*100)/100,0.03,0.10);
    var gia=Math.floor(x.gia*(1-d)/5000)*5000;
    var dd=1-gia/x.gia;
    var cnt=Math.round(c.N*c.T*share[i]*Math.min(1,c.A*2/x.gia));
    chiPhi+=cnt*(x.gia-gia); ds+=cnt*gia*0.6;
    rows.push({x:x, bien:bien, gia:gia, d:dd, cnt:cnt, bienSau:(bien-dd)/(1-dd)});
    kb.push({tinh:x.ten, noi:x.mo});
  });
  kb.push({tinh:"Nguyên tắc", noi:"Chỉ gợi ý đủ bộ khi đúng triệu chứng, đúng đối tượng. Khách chỉ cần một món thì bán một món. Không đưa thuốc kê đơn vào combo."});
  return {
    muc:"Tăng số sản phẩm trên mỗi hóa đơn và kéo nhóm TPCN, chăm sóc có biên cao đi cùng nhóm hàng khách tự tìm đến.",
    doiTuong:"Khách có nhu cầu đúng với từng combo — dược sĩ hỏi triệu chứng trước khi gợi ý.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to)+" (combo theo mùa, có thể giữ tiếp nếu bán tốt)",
    bang:{head:["Combo","Thành phần","Giá lẻ cộng","Giá combo","Biên sau ưu đãi","Dự kiến bán"],
      rows:rows.map(function(r){return ['<b>'+esc(r.x.ten)+'</b>', r.x.mon.map(function(mm){return esc(mm[0])+' <span class="tag">'+mm[1]+'</span>';}).join("<br>"), vnd(r.x.gia), '<b>'+vnd(r.gia)+'</b><br><span class="muted">giảm '+pct(r.d,0)+'</span>', pct(r.bienSau), r.cnt+" combo"];})},
    dieuKien:["Giá lẻ trong bảng là giá tham khảo — quầy thay bằng sản phẩm và giá thật đang bán.","Thuốc trong combo giữ đúng giá niêm yết; phần giảm trừ vào sản phẩm hỗ trợ và chăm sóc.","TPCN trong combo phải ghi rõ: Thực phẩm này không phải là thuốc, không có tác dụng thay thế thuốc chữa bệnh.","Đóng gói sẵn trong túi có nhãn tên combo và thành phần."],
    combos:rows, qua:[],
    kichBan:kb,
    poster:{hl:list[0]?list[0].ten:"Combo chăm sóc", sub:rows.map(function(r){return r.x.ten+" "+kk(r.gia);}).join(" · ")},
    zalo:"[Tên quầy] đã chuẩn bị sẵn các gói chăm sóc theo mùa:\n"+rows.map(function(r){return "• "+r.x.ten+": "+vnd(r.gia)+" (tiết kiệm "+vnd(r.x.gia-r.gia)+")";}).join("\n")+"\nAnh/chị nhắn quầy để được dược sĩ tư vấn đúng nhu cầu trước khi mua nhé.",
    kpi:[["Số combo bán / ngày", "≥ "+Math.max(1,Math.round(rows.reduce(function(a,r){return a+r.cnt;},0)/c.T))],["Số sản phẩm / hóa đơn", "tăng ≥ 0,3"],["Biên lãi các combo", "≥ "+pct(Math.min.apply(null,rows.map(function(r){return r.bienSau;})),0)]],
    chuanBi:["Chọn sản phẩm thật cho từng thành phần, ưu tiên hàng biên cao và hàng độc quyền.","Đóng sẵn 10–20 túi mỗi combo, trưng bày ngay quầy tư vấn.","Viết thẻ nhỏ: dành cho ai, dùng thế nào, khi nào phải đi khám."],
    chiPhi:chiPhi, dsTang:ds,
    moTaNgan:rows.length+" combo theo mùa"
  };
};

GEN.voucher = function(c) {
  const S = c.S || mauState();
  var X=niceUp(c.A*2), Y=niceUp(c.A*1.5), V=nice5k(Math.min(Y*0.1, Y*c.bKM*0.3));
  var han=c.zalo?21:14;
  var phat=Math.round(c.N*c.T*0.18*c.m.tyKM/0.7), tyDung=c.zalo?0.40:0.28, dung=Math.round(phat*tyDung);
  var ketThucDung=addDays(c.to,han);
  return {
    muc:"Biến khách mua một lần thành khách quay lại trong "+han+" ngày.",
    doiTuong:"Khách có hóa đơn từ "+vnd(X)+" trong thời gian chương trình.",
    thoiGian:"Phát phiếu "+dmyy(c.from)+" – "+dmyy(c.to)+" · dùng phiếu đến hết "+dmyy(ketThucDung),
    bang:{head:["Hạng mục","Nội dung"],rows:[
      ["Điều kiện nhận phiếu","Hóa đơn từ <b>"+vnd(X)+"</b>"],
      ["Giá trị phiếu","<b>"+vnd(V)+"</b> — mỗi hóa đơn 1 phiếu"],
      ["Điều kiện dùng","Hóa đơn lần sau từ "+vnd(Y)+", dùng từ ngày hôm sau, hạn "+han+" ngày kể từ ngày nhận"],
      ["Dự kiến phát / dùng",phat+" phiếu / "+dung+" phiếu (tỷ lệ dùng "+pct(tyDung,0)+")"],
      ["Mã phiếu","VC-0001 đến VC-"+String(Math.ceil(phat*1.2)).padStart(4,"0")+" — đã tạo sẵn trong file Excel"]
    ]},
    dieuKien:["Phiếu ghi rõ giá trị, hạn dùng, điều kiện dùng, có mã số và chữ ký/đóng dấu quầy.","Không quy đổi thành tiền mặt, không trả lại tiền thừa.",LOAI_TRU_KM,"Mỗi hóa đơn dùng tối đa 1 phiếu."],
    qua:[], X:X, V:V, Y:Y, han:han, phat:phat,
    kichBan:[
      {tinh:"Khi tính tiền hóa đơn đủ điều kiện", noi:"Hôm nay hóa đơn của anh/chị đủ "+kk(X)+", em gửi anh/chị phiếu "+kk(V)+" dùng cho lần mua sau từ "+kk(Y)+", hạn "+han+" ngày. Em lưu số Zalo để nhắc anh/chị trước khi phiếu hết hạn nhé."},
      {tinh:"Khách đưa phiếu", noi:"Em kiểm tra mã phiếu trên sổ, trừ "+kk(V)+" và ghi ngày dùng. Anh/chị vẫn được tích điểm trên số tiền thực trả."}
    ],
    poster:{hl:"Mua hôm nay — tặng "+kk(V)+" cho lần sau", sub:"Hóa đơn từ "+kk(X)+" nhận phiếu "+kk(V)+", dùng trong "+han+" ngày"},
    zalo:"[Tên quầy] nhắc anh/chị: phiếu "+vnd(V)+" mã [MÃ PHIẾU] sẽ hết hạn vào ngày [NGÀY]. Anh/chị ghé quầy trước ngày đó để dùng cho hóa đơn từ "+vnd(Y)+" nhé. Cần tư vấn gì cứ nhắn quầy ạ.",
    kpi:[["Tỷ lệ phiếu được dùng", "≥ "+pct(tyDung,0)],["Khách quay lại trong "+han+" ngày", "≥ "+dung+" lượt"],["Giá trị hóa đơn dùng phiếu", "≥ "+vnd(Y)]],
    chuanBi:["In phiếu có mã số liên tục (lấy danh sách mã ở sheet 6 file Excel).","Nhắn Zalo nhắc khách 3 ngày trước khi phiếu hết hạn.","Giao một người giữ sổ phiếu, đối chiếu mỗi cuối ngày."],
    chiPhi:dung*V, dsTang:dung*Y*1.2*0.6,
    moTaNgan:"HĐ từ "+kk(X)+" tặng phiếu "+kk(V)
  };
};

GEN.tichdiem = function(c) {
  const S = c.S || mauState();
  var r=clamp(c.bKM*0.08,0.01,0.025), V100=Math.round(1e6*r/1000)*1000;
  var bac=niceUp(c.A*12), vang=niceUp(c.A*35);
  var dk=Math.round(c.N*c.T*0.12), thuong=20;
  var qBac=chonQua(c.kho, 35000, Math.max(3,Math.round(dk*0.02)), 0, "Sinh nhật Bạc");
  var qVang=chonQua(c.kho, 90000, Math.max(2,Math.round(dk*0.01)), 0, "Sinh nhật Vàng");
  var chiPhi=c.DSky*c.m.tyKM*0.4*r*0.6 + dk*thuong*V100/100*0.6 + sumCost(qBac)+sumCost(qVang);
  return {
    muc:"Giữ khách quen quay lại quầy mình thay vì quầy bên cạnh, đồng thời có danh sách số điện thoại để chăm sóc.",
    doiTuong:"Mọi khách đồng ý để lại tên và số điện thoại.",
    thoiGian:"Khởi động "+dmyy(c.from)+", chạy liên tục (điểm có hạn 12 tháng)",
    bang:{head:["Hạng","Điều kiện (chi tiêu 6 tháng)","Hệ số điểm","Quyền lợi"],rows:[
      ["Thành viên","Đăng ký là có","×1,0","Tặng "+thuong+" điểm khi đăng ký trong kỳ khởi động"],
      ["Bạc","Từ "+vnd(bac),"×1,2","Quà sinh nhật: <span class='giftcell'>"+esc(tenQua(qBac))+"</span>"],
      ["Vàng","Từ "+vnd(vang),"×1,5","Quà sinh nhật: <span class='giftcell'>"+esc(tenQua(qVang))+"</span> · ưu tiên đo huyết áp, tư vấn riêng"],
      ["Quy đổi","10.000đ = 1 điểm","","<b>100 điểm = phiếu "+vnd(V100)+"</b> (hoàn lại "+pct(r,1)+" giá trị mua)"]
    ]},
    dieuKien:[LOAI_TRU_KM,"Tích điểm trên số tiền thực trả sau khi trừ phiếu và giảm giá.","Điểm có hạn 12 tháng kể từ ngày tích; không quy đổi thành tiền mặt.","Theo Nghị định 239/2026/NĐ-CP, chương trình khách hàng thường xuyên không phải thông báo Sở Công Thương — vẫn phải niêm yết thể lệ tại quầy."],
    qua:qBac.concat(qVang), V100:V100, bac:bac, vang:vang,
    kichBan:[
      {tinh:"Khách mới", noi:"Anh/chị cho em xin tên và số điện thoại để tích điểm nhé, mỗi 10.000đ được 1 điểm, đủ 100 điểm đổi phiếu "+kk(V100)+". Đăng ký hôm nay được tặng luôn "+thuong+" điểm."},
      {tinh:"Khách gần đủ điểm", noi:"Anh/chị đang có [x] điểm, còn [y] điểm nữa là đổi được phiếu "+kk(V100)+"."}
    ],
    poster:{hl:"Mua càng nhiều — điểm càng nhiều", sub:"10.000đ = 1 điểm · 100 điểm = phiếu "+kk(V100)+" · Quà sinh nhật hạng Bạc, Vàng"},
    zalo:"Chúc mừng sinh nhật anh/chị [Tên]! [Tên quầy] có món quà nhỏ dành cho thành viên hạng [Bạc/Vàng], anh/chị ghé quầy nhận trong tháng này nhé. Hiện anh/chị đang có [x] điểm.",
    kpi:[["Thành viên mới trong kỳ", "≥ "+dk],["Tỷ lệ hóa đơn có số điện thoại", "≥ 50%"],["Thành viên quay lại trong 30 ngày", "≥ 35%"]],
    chuanBi:[S.kenh.indexOf("phanmem")>=0?"Cài quy tắc điểm và hạng trên phần mềm bán hàng.":"Chưa có phần mềm tích điểm: dùng sheet 7 file Excel, mỗi cuối ngày cập nhật chi tiêu theo số điện thoại.","In thẻ thành viên hoặc thẻ cứng ghi tên + số điện thoại.","Tạo nhóm Zalo thành viên để gửi thông báo."],
    chiPhi:chiPhi, dsTang:c.DSky*c.m.tyKM*0.05, ds90:c.DSky*c.m.tyKM*0.03,
    moTaNgan:"100 điểm = "+kk(V100)
  };
};

GEN.gioithieu = function(c) {
  const S = c.S || mauState();
  var Y=niceUp(c.A*1.5), R=nice5k(c.A*0.12);
  var cnt=Math.max(5,Math.round(c.N*c.T*0.015));
  var q=chonQua(c.kho, Y*0.1, cnt, Y*c.bKM*0.35, "Quà khách mới");
  return {
    muc:"Có thêm khách mới nhờ khách cũ, chi phí thấp hơn quảng cáo.",
    doiTuong:"Khách cũ (người giới thiệu) và người lần đầu mua tại quầy (người được giới thiệu).",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to),
    bang:{head:["Bên","Điều kiện","Nhận được"],rows:[
      ["Người được giới thiệu","Lần đầu mua tại quầy, hóa đơn từ "+vnd(Y)+", đọc tên hoặc số điện thoại người giới thiệu","<span class='giftcell'>"+esc(tenQua(q))+"</span>"],
      ["Người giới thiệu","Mỗi người mới mua thành công","Phiếu "+vnd(R)+" dùng lần sau (không giới hạn số lần giới thiệu)"],
      ["Dự kiến","",cnt+" khách mới trong kỳ"]
    ]},
    dieuKien:["Ghi nhận bằng số điện thoại người giới thiệu trên phần mềm hoặc sheet Phát quà.","Người được giới thiệu phải là khách chưa từng có hóa đơn tại quầy.",LOAI_TRU_KM],
    qua:q, Y:Y, R:R,
    kichBan:[{tinh:"Khi khách quen thanh toán", noi:"Anh/chị có người nhà, hàng xóm hay mua thuốc không ạ? Anh/chị giới thiệu tới quầy, người đó được tặng quà, còn anh/chị nhận phiếu "+kk(R)+" cho mỗi người."}],
    poster:{hl:"Rủ người quen — cả hai cùng có quà", sub:"Người mới: quà khi mua từ "+kk(Y)+" · Người giới thiệu: phiếu "+kk(R)},
    zalo:"[Tên quầy] gửi anh/chị: giới thiệu người thân, bạn bè đến quầy, người mới được tặng quà khi mua từ "+vnd(Y)+", anh/chị nhận phiếu "+vnd(R)+" cho mỗi người. Chỉ cần người mới đọc số điện thoại của anh/chị khi thanh toán.",
    kpi:[["Khách mới qua giới thiệu", "≥ "+cnt],["Tỷ lệ khách mới quay lại lần 2", "≥ 40%"]],
    chuanBi:["In thẻ giới thiệu nhỏ để khách cũ cầm về.","Nhân viên hỏi mọi khách lạ: anh/chị biết quầy qua ai?"],
    chiPhi:sumCost(q)+cnt*R*0.7, dsTang:cnt*c.A*2.2, ds90:cnt*0.4*2*c.A,
    moTaNgan:"Mỗi giới thiệu = phiếu "+kk(R)
  };
};

var GEN_KT, GEN_TA;
GEN_KT = function(c) {
  const S = c.S || mauState();
  const doOn = c.pf?.doSK === "co";
  var truoc=addDays(c.from,-7), p3=addDays(c.from, Math.max(1, c.evDays - 1)), giuTu=addDays(c.from, c.evDays);
  var giuDen = c.T>=10 ? c.to : addDays(c.from,29);
  var moHang=chonQua(c.kho, 12000, 50*c.evDays, 9000, "Quà mở hàng");
  var dangKy=chonQua(c.kho, 25000, Math.round(c.N0*1.8*c.evDays*0.5), 15000, "Quà đăng ký thành viên");
  var Q=niceUp(c.A*1.5);
  var chiPhi=sumCost(moHang)+sumCost(dangKy);
  var kb=[
    {tinh:"Khách vào cửa", noi: doOn ? "Chào anh/chị, hôm nay quầy khai trương, anh/chị nhận giúp em phần quà mở hàng. Em đo huyết áp miễn phí cho anh/chị luôn nhé." : "Chào anh/chị, hôm nay quầy khai trương, anh/chị nhận giúp em phần quà mở hàng. Dược sĩ quầy tư vấn sức khỏe và dùng thuốc an toàn miễn phí cho anh/chị luôn nhé."},
    {tinh:"Khi thanh toán", noi:"Anh/chị cho em xin số điện thoại để làm thẻ thành viên, tặng luôn "+tenQua(dangKy).toLowerCase()+" và nhận tin ưu đãi của quầy."}
  ];
  return {
    muc:"Cho cả khu vực biết quầy đã mở, có "+Math.round(c.N0*1.8*c.evDays*0.5)+" số điện thoại khách đầu tiên và đưa doanh số về mức mục tiêu trong 30 ngày.",
    doiTuong:"Dân cư trong bán kính 1–2 km, khách đi đường, người quen của chủ quầy và nhân viên.",
    thoiGian:"Hâm nóng "+dmy(truoc)+" – "+dmy(addDays(c.from,-1))+" · Cao điểm "+c.evDays+" ngày: "+dmy(c.from)+" – "+dmy(p3)+" · Giữ khách "+dmy(giuTu)+" – "+dmyy(giuDen),
    bang:{head:["Giai đoạn","Thời gian","Việc làm","Quà / ưu đãi"],rows:[
      ["Hâm nóng",dmy(truoc)+" – "+dmy(addDays(c.from,-1)),"Treo băng rôn, phát tờ rơi bán kính 1 km"+(S.khuVuc==="nongthon"||S.khuVuc==="thitran"?", nhờ loa thôn/xóm thông báo":"")+"; đăng bài nhóm Facebook khu vực; người quen chia sẻ Zalo","Tờ rơi có phiếu nhận quà mở hàng"],
      ["Cao điểm "+c.evDays+" ngày",dmy(c.from)+" – "+dmy(p3),"Mở cửa sớm 30 phút; "+(doOn ? "đo huyết áp, cân nặng miễn phí; dược sĩ tư vấn tại bàn riêng" : "dược sĩ tư vấn sức khỏe tại bàn riêng")+"; làm thẻ thành viên"+(c.has("boctham")?"; bốc thăm may mắn":""),"50 suất quà mở hàng mỗi ngày: <span class='giftcell'>"+esc(tenQua(moHang))+"</span> · Đăng ký thành viên: <span class='giftcell'>"+esc(tenQua(dangKy))+"</span>"+(c.has("moc")?" · Mốc hóa đơn tăng tỷ lệ tham gia":"")],
      ["Giữ khách",dmy(giuTu)+" – "+dmy(giuDen),"Nhắn Zalo cảm ơn khách đã ghé; nhắc phiếu lần sau"+(doOn ? "; mời ngày đo sức khỏe miễn phí tiếp theo" : "; mời lịch tư vấn sức khỏe định kỳ"),(c.has("voucher")?"Phiếu mua lần sau":"Phiếu "+kk(nice5k(c.A*0.1))+" cho hóa đơn từ "+kk(Q)+" trong 30 ngày")]
    ]},
    dieuKien:["Quà mở hàng tặng không kèm điều kiện mua — mỗi khách 1 suất/ngày.","Ghi rõ số suất quà mỗi ngày trên băng rôn để tránh tranh cãi.",LOAI_TRU_KM,"Chỉ khai trương khi đã có Giấy chứng nhận đủ điều kiện kinhdong dược và người phụ trách chuyên môn có mặt."],
    qua:moHang.concat(dangKy),
    kichBan:kb,
    poster:{hl:"Khai trương "+dmy(c.from)+" — 50 phần quà mỗi ngày", sub: (doOn ? "Đo huyết áp miễn phí · " : "") + "Làm thẻ thành viên nhận quà · Dược sĩ tư vấn tận tâm"},
    zalo:"[Tên quầy] chính thức khai trương ngày "+dmyy(c.from)+" tại [địa chỉ].\n• 50 phần quà mở hàng mỗi ngày trong "+c.evDays+" ngày đầu\n" + (doOn ? "• Đo huyết áp, cân nặng miễn phí\n" : "• Dược sĩ tư vấn dùng thuốc an toàn miễn phí\n") + "• Làm thẻ thành viên nhận thêm quà\nRất mong được đón anh/chị và gia đình!",
    kpi:[["Lượt khách "+c.evDays+" ngày cao điểm", "≥ "+Math.round(c.N0*1.8*c.evDays)],["Số điện thoại thu được", "≥ "+Math.round(c.N0*1.8*c.evDays*0.5)],["Doanh số trung bình 30 ngày đầu", "≥ "+tr(c.D)+"/ngày"]],
    chuanBi:["Hồ sơ pháp lý đầy đủ, treo đúng vị trí; niêm yết giá toàn bộ hàng.","Đủ danh mục hàng khởi đầu theo tệp khách khu vực.","Phần mềm bán hàng, máy in hóa đơn, tích điểm chạy thử trước 2 ngày.","Nhân viên tập kịch bản đón khách, "+(doOn ? "đo huyết áp, " : "tư vấn, ")+"làm thẻ."],
    chiPhi:chiPhi, dsTang:0,
    moTaNgan: c.evDays+" ngày cao điểm, 50 quà/ngày"
  };
};

GEN_TA = function(c) {
  const S = c.S || mauState();
  const doOn = c.pf?.doSK === "co";
  var cuoiNam = c.month===12 || c.month===1;
  var ten = cuoiNam ? "Tri ân cuối năm — đón Tết" : "Tuần lễ tri ân khách hàng";
  var top=Math.min(50,Math.max(15,Math.round(c.N0*0.5)));
  var qTop=chonQua(c.kho, niceUp(c.A*0.6), top, 0, "Quà tri ân khách thân thiết");
  var M=niceUp(c.A*2.2), cnt=Math.round(c.N0*c.T*0.12);
  var qHD=chonQua(c.kho, M*0.08, c.has("moc")?0:cnt, M*c.bKM*0.35, "Quà hóa đơn tri ân");
  var rows=[
    ["Quà tri ân khách thân thiết", top+" khách có chi tiêu cao nhất 6 tháng qua", "<span class='giftcell'>"+esc(tenQua(qTop))+"</span> kèm thiếp cảm ơn viết tay"],
    [c.has("moc")?"Mốc hóa đơn":"Quà theo hóa đơn", c.has("moc")?"Dùng bảng mốc của chương trình mốc quà":"Hóa đơn từ "+vnd(M), c.has("moc")?"Như bảng mốc":"<span class='giftcell'>"+esc(tenQua(qHD))+"</span>"],
    ["Ưu đãi thành viên", c.has("tichdiem")?"Mọi thành viên":"Khách để lại số điện thoại", c.has("tichdiem")?"Nhân đôi điểm trong tuần tri ân":"Tặng phiếu "+kk(nice5k(c.A*0.1))+" dùng trong tháng sau"],
    ["Chăm sóc", "Mọi khách", doOn ? "Đo huyết áp miễn phí, thư cảm ơn qua Zalo" : "Dược sĩ tư vấn sức khỏe miễn phí, thư cảm ơn qua Zalo"]
  ];
  var extra = c.has("tichdiem") ? c.DSky*0.4*0.02*0.6*Math.min(1,10/c.T) : c.N0*c.T*0.2*nice5k(c.A*0.1)*0.3;
  return {
    ten:ten,
    muc:"Cảm ơn khách đã gắn bó, tăng độ thân thiết và kéo khách ít ghé quay lại quầy.",
    doiTuong:"Khách thân thiết (nhóm quà riêng) và mọi khách mua trong tuần tri ân.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to)+(c.T>14?" (nên gói gọn 7–10 ngày để tạo cảm giác đặc biệt)":""),
    bang:{head:["Hoạt động","Áp dụng cho","Quà / ưu đãi"],rows:rows},
    dieuKien:["Danh sách khách thân thiết lấy từ phần mềm hoặc sheet 7, chốt trước ngày bắt đầu 5 ngày.","Nhắn Zalo mời riêng từng khách thân thiết đến nhận quà.",LOAI_TRU_KM],
    qua:qTop.concat(qHD), top:top,
    kichBan:[{tinh:"Khách thân thiết đến nhận quà", noi:"Cảm ơn cô/chú/anh/chị đã tin tưởng quầy suốt thời gian qua. Đây là phần quà nhỏ quầy gửi riêng, mong tiếp tục được chăm sóc sức khỏe cho cả nhà."},
             {tinh:"Khách thường", noi:"Tuần này quầy tri ân khách hàng, anh/chị được "+(c.has("tichdiem")?"nhân đôi điểm":"tặng phiếu dùng tháng sau")+(doOn ? " và đo huyết áp miễn phí nhé." : " và được dược sĩ tư vấn sức khỏe miễn phí nhé.")}],
    poster:{hl:ten, sub:"Quà cho khách thân thiết · "+(c.has("tichdiem")?"Nhân đôi điểm":"Phiếu mua tháng sau")+(doOn ? " · Đo huyết áp miễn phí" : " · Dược sĩ tư vấn tận tâm")},
    zalo:"Thân gửi [Tên khách], cảm ơn anh/chị đã đồng hành cùng [Tên quầy]. Quầy có món quà tri ân dành riêng cho anh/chị, mời anh/chị ghé nhận từ "+dmy(c.from)+" đến "+dmy(c.to)+". Chúc cả nhà luôn mạnh khỏe!",
    kpi:[["Khách thân thiết đến nhận quà", "≥ 70% ("+Math.round(top*0.7)+" người)"],["Doanh số tuần tri ân", "tăng ≥ 10%"],["Khách lâu không ghé quay lại", "≥ 15 người"]],
    chuanBi:["Lọc danh sách khách thân thiết, gói quà ghi tên từng người.","Viết thiếp cảm ơn tay (chủ quầy ký).", doOn ? "Chuẩn bị bàn đo huyết áp cạnh cửa." : "Chuẩn bị bàn tư vấn sức khỏe cạnh cửa."],
    chiPhi:sumCost(qTop)+sumCost(qHD), cpKhac:{nhom:"giam", ten:"Nhân đôi điểm / phiếu tri ân", tien:extra}, dsTang:0,
    moTaNgan:top+" khách thân thiết"
  };
};

GEN.khaitruong = function(c) {
  const S = c.S || mauState(); var p=GEN_KT(c); return ganSuKien(c,p,"khaitruong", c.D*Math.max(0,c.T-c.evDays)*0.08); };
GEN.trian = function(c) {
  const S = c.S || mauState(); var p=GEN_TA(c); return ganSuKien(c,p,"trian", c.DSky*0.04); };

GEN.ngayhoi = function(c) {
  const S = c.S || mauState();
  var f0=suKien(c,"ngayhoi");
  var doOn=f0.doOn;
  var ngayCuoi=addDays(c.from,c.evDays-1);
  var nho=S.ct.map(function(id){return progOf(id).ten;});
  var tv={quay:"Dược sĩ của quầy",hang:"Dược sĩ của hãng",chuyengia:"Chuyên gia / bác sĩ phối hợp"}[c.pf.tuVan]||"Dược sĩ của quầy";

  var kb = doOn ? [
    {tinh:"Bước 1 — Đo và ghi sổ", noi:"Mời bác ngồi nghỉ 5 phút rồi con đo. Con ghi chỉ số vào sổ để bác mang về, lần sau so sánh."},
    {tinh:"Bước 2 — Hỏi 3 câu", noi:"Bác đang dùng thuốc gì không ạ? Ăn uống, ngủ, đi lại dạo này thế nào? Trong nhà có ai cần đo không ạ?"},
    {tinh:"Bước 3 — Giải thích chỉ số", noi:"Huyết áp của bác hôm nay là [x/y], so với mức an toàn là [cao hơn/ổn]. Con nói đơn giản để bác dễ nhớ…"},
    {tinh:"Bước 4 — Gợi ý đúng 1 nhóm", noi:"Với chỉ số này, bác nên [lời khuyên lối sống]. Nếu muốn hỗ trợ thêm, quầy có [nhóm TPCN], đây là thực phẩm bảo vệ sức khỏe, không thay thuốc. Hôm nay đang có ưu đãi [chương trình nhỏ]."},
    {tinh:"Bước 5 — Hẹn và lưu Zalo", noi:"Con lưu Zalo của bác, tháng sau quầy nhắc bác qua đo lại miễn phí nhé."}
  ] : [
    {tinh:"Bước 1 — Đón khách & Mời nước", noi:"Chào bác, mời bác ngồi uống nước. Hôm nay quầy có ngày hội tư vấn sức khỏe và kiểm tra đơn thuốc miễn phí cho bà con."},
    {tinh:"Bước 2 — Hỏi thăm sức khỏe", noi:"Bác đang dùng thuốc gì không ạ? Ăn uống, ngủ nghỉ dạo này thế nào? Trong nhà có ai đang điều trị bệnh mạn tính không ạ?"},
    {tinh:"Bước 3 — Rà soát thuốc & lối sống", noi:"Bác mang đơn hoặc sổ khám, con kiểm tra xem có lưu ý gì khi uống hoặc thời gian uống thuốc có cần chỉnh lại không…"},
    {tinh:"Bước 4 — Gợi ý bổ sung & dùng thử", noi:"Với tình trạng của bác, quầy gửi bác mẫu dùng thử [TPCN], thảo dược hỗ trợ rất lành tính. Hôm nay đang có ưu đãi [chương trình nhỏ]."},
    {tinh:"Bước 5 — Hẹn và lưu Zalo", noi:"Con lưu Zalo của bác, tuần tới con nhắn hỏi thăm xem bác uống thuốc và dùng thử thấy thế nào nhé."}
  ];

  var kpiList = doOn ? [
    ["Lượt đo sức khỏe", "≥ "+f0.luotDo],
    ["Tỷ lệ mua TPCN sau tư vấn", "≥ "+pct(f0.cr,0)],
    ["Lượt để lại SĐT / Zalo", "≥ 60% lượt đo"],
    ["Doanh số ngày hội", "≥ "+tr(c.D*c.h)+"/ngày"]
  ] : [
    ["Lượt khách tư vấn chuyên sâu", "≥ "+Math.round(f0.visits * 0.35)],
    ["Đơn TPCN mua thêm", "≥ "+f0.donTPCN],
    ["Lượt để lại SĐT / Zalo", "≥ 40% lượt khách"],
    ["Doanh số ngày hội", "≥ "+tr(c.D*c.h)+"/ngày"]
  ];

  var p={
    muc: doOn ? "Kéo khách mới và khách lâu không ghé vào quầy bằng đo sức khỏe miễn phí, rồi biến lượt đo thành đơn TPCN qua tư vấn đúng nhu cầu." : "Kéo khách vào quầy bằng tư vấn dùng thuốc an toàn và dùng thử TPCN, chăm sóc khách mạn tính để tăng doanh số TPCN.",
    doiTuong:"Người cao tuổi, người đang điều trị huyết áp, tiểu đường, gia đình trong bán kính 1–2 km.",
    thoiGian:"Cao điểm "+c.evDays+" ngày: "+dmyy(c.from)+(c.evDays>1?" – "+dmyy(ngayCuoi):"")+" · sáng 7h–11h, chiều 15h–18h · các chương trình nhỏ chạy đến "+dmyy(c.to),
    bang:{head:["Khu vực","Nội dung"],rows:[
      ["Bàn đón & tư vấn", doOn ? ("Huyết áp, cân nặng, BMI · "+f0.nguoi+" người trực · công suất khoảng "+f0.cap+" lượt ("+(f0.nguoi*12)+" lượt/giờ)") : "Bàn tư vấn dùng thuốc an toàn, kiểm tra đơn thuốc và chỉ dẫn lối sống"],
      ["Bàn tư vấn TPCN", tv+" · tư vấn theo bảng tình huống bên dưới, lưu Zalo, hẹn tái khám"],
      ["Góc dùng thử", c.has("dungthu") ? "Theo chương trình Dùng thử" : (f0.mauN>0 ? f0.mauN+" mẫu TPCN, mỹ phẩm, kèm phiếu mua sản phẩm chính" : "Chưa có mẫu — nên xin hãng")],
      ["Quà cho người tham gia", f0.quaDo.length ? "<span class='giftcell'>"+esc(tenQua(f0.quaDo))+"</span>" : (doOn ? "—" : "Mẫu dùng thử / quà nhỏ")],
      ["Ưu đãi tại quầy", nho.length ? esc(nho.join(" · ")) : "<span class='tag warn'>Chưa chọn chương trình nhỏ</span>"]
    ]},
    dieuKien:[],
    qua:[],
    kichBan: kb,
    poster:{
      hl: doOn ? "Ngày hội sức khỏe — Đo huyết áp, cân nặng MIỄN PHÍ" : "Ngày hội sức khỏe — Tư vấn sức khỏe & DÙNG THỬ MIỄN PHÍ",
      sub: dmy(c.from)+(c.evDays>1?" – "+dmy(ngayCuoi):"")+" · 7h–11h, 15h–18h · Dược sĩ hướng dẫn dùng thuốc an toàn · Quà cho người tham gia"
    },
    zalo: doOn ?
      "[Tên quầy] mời anh/chị và gia đình tham gia Ngày hội sức khỏe "+dmy(c.from)+(c.evDays>1?" – "+dmy(ngayCuoi):"")+":\n• Đo huyết áp, cân nặng, BMI miễn phí\n• Dược sĩ hướng dẫn dùng thuốc an toàn\n• Quà nhỏ cho người tham gia\nNên mang theo sổ khám hoặc đơn thuốc đang dùng. Địa chỉ: [..] · Hotline: [..]" :
      "[Tên quầy] mời anh/chị và gia đình tham gia Ngày hội tư vấn sức khỏe "+dmy(c.from)+(c.evDays>1?" – "+dmy(ngayCuoi):"")+":\n• Hướng dẫn dùng thuốc an toàn, kiểm tra đơn thuốc miễn phí\n• Trải nghiệm dùng thử mẫu TPCN chính hãng\n• Quà nhỏ cho người tham gia\nĐịa chỉ: [..] · Hotline: [..]",
    kpi: kpiList,
    chuanBi: doOn ?
      ["2 máy đo huyết áp đã kiểm tra, cân, thước dây; sổ theo dõi in sẵn có QR Zalo quầy.","Bàn ghế, nước uống, ô che nắng nếu đặt ngoài mặt tiền.","Đủ tồn TPCN cho khoảng "+f0.donTPCN+" đơn; đóng sẵn combo.","Phân công: người đón – người đo – dược sĩ tư vấn – thu ngân.","Dược sĩ phụ trách duyệt bảng gợi ý sau đo trước ngày hội."] :
      ["Bàn ghế tư vấn riêng, nước uống, sổ theo dõi sức khỏe và đơn thuốc in sẵn có QR Zalo quầy.","Đủ mẫu thử TPCN, mỹ phẩm và tồn hàng cho khoảng "+f0.donTPCN+" đơn TPCN.","Phân công: người đón khách – dược sĩ tư vấn chuyên môn – thu ngân.","Dược sĩ phụ trách duyệt bảng tình huống tư vấn trước ngày hội."],
    chiPhi:0, dsTang:0,
    moTaNgan: (doOn ? f0.luotDo+" lượt đo · " : "Tư vấn & dùng thử · ") + c.evDays+" ngày cao điểm"
  };
  return ganSuKien(c,p,"ngayhoi",0,f0);
};

GEN.muanhieu = function(c) {
  const S = c.S || mauState();
  var d3=clamp(Math.round(c.bienTPCN*0.4*100)/100,0.08,0.15), d2=Math.max(0.05,Math.round(d3*0.55*100)/100);
  var p1=c.giaTPCN;
  var base=c.N*c.T*0.06;
  var n2=Math.round(base*0.25), n3=Math.round(base*0.10);
  var ds=n2*2*p1*(1-d2)+n3*3*p1*(1-d3)-(n2+n3)*p1;
  var cp=n2*2*p1*d2+n3*3*p1*d3;
  var gia3=Math.round(p1*(1-d3)/1000)*1000;
  return {
    muc:"Khách mua đủ liệu trình TPCN (2–3 tháng) thay vì mua lẻ từng hộp — tăng giá trị đơn, tăng hiệu quả dùng và tăng khả năng quay lại.",
    doiTuong:"Khách mua TPCN, dược mỹ phẩm đã được tư vấn đúng nhu cầu.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to),
    bang:{head:["Mua","Giảm","Ví dụ với hộp "+kk(p1),"Biên còn lại","Dự kiến"],rows:[
      ["2 hộp cùng loại", pct(d2,0), vnd(2*p1)+" → <b>"+vnd(2*p1*(1-d2))+"</b>", pct((c.bienTPCN-d2)/(1-d2)), n2+" đơn"],
      ["3 hộp cùng loại", pct(d3,0), vnd(3*p1)+" → <b>"+vnd(3*p1*(1-d3))+"</b> (≈ "+vnd(gia3)+"/hộp)", pct((c.bienTPCN-d3)/(1-d3)), n3+" đơn"]
    ]},
    dieuKien:["Chỉ áp dụng TPCN, dược mỹ phẩm — không áp dụng cho thuốc.","Tư vấn đủ liệu trình theo hướng dẫn nhà sản xuất, không ép mua nhiều.","Hàng mua nhiều phải còn hạn dùng dài hơn thời gian dùng hết.","Sản phẩm đã giảm theo combo không giảm tiếp theo chương trình này."],
    qua:[],
    kichBan:[{tinh:"Sau khi khách chọn 1 hộp", noi:"Sản phẩm này dùng đủ 2–3 tháng mới thấy rõ. Anh/chị lấy 3 hộp thì được giảm "+pct(d3,0)+", tính ra mỗi hộp còn khoảng "+vnd(gia3)+", lại không phải quay lại mua giữa chừng."},
             {tinh:"Khách ngại tiền", noi:"Anh/chị lấy 2 hộp trước cũng được giảm "+pct(d2,0)+", dùng hết em nhắc qua Zalo."}],
    poster:{hl:"Mua đủ liệu trình — tiết kiệm đến "+pct(d3,0), sub:"Mua 2 hộp giảm "+pct(d2,0)+" · Mua 3 hộp giảm "+pct(d3,0)+" · Áp dụng TPCN, dược mỹ phẩm"},
    zalo:"[Tên quầy] nhắc anh/chị: [sản phẩm] anh/chị đang dùng sắp hết. Tuần này mua 2 hộp giảm "+pct(d2,0)+", 3 hộp giảm "+pct(d3,0)+" để dùng đủ liệu trình. Anh/chị nhắn quầy giữ hàng nhé.",
    kpi:[["Số hộp TPCN / đơn TPCN", "≥ 1,5"],["Đơn mua 2–3 hộp", "≥ "+(n2+n3)],["Khách quay lại mua tiếp sau liệu trình", "≥ 40%"]],
    chuanBi:["Chọn 5–10 mã TPCN biên tốt, hạn dùng dài.","Dán nhãn giá mua 2 / mua 3 ngay trên kệ.","Nhập đủ hàng; hỏi hãng hỗ trợ chiết khấu cho phần giảm."],
    chiPhi:cp, dsTang:ds, laiGop:ds*c.bienTPCN, ds90:(n2+n3)*0.4*p1*2, lai90:(n2+n3)*0.4*p1*2*c.bienTPCN,
    moTaNgan:"Mua 2 −"+pct(d2,0)+" · mua 3 −"+pct(d3,0)
  };
};

GEN.dungthu = function(c) {
  const S = c.S || mauState();
  var mauN=Math.round(num(c.pf.mau)||0) || Math.round(c.N0*c.T*0.1);
  var giaMau=(num(c.pf.giaMau)||0)*1000;
  var dung=Math.round(mauN*0.12);
  var phan=Math.min(1, c.T/21);
  var giamPhieu=0.1;
  return {
    muc:"Cho khách trải nghiệm TPCN, mỹ phẩm trước khi mua — cửa vào của khách mới với nhóm hàng biên cao.",
    doiTuong:"Khách được tư vấn đúng nhu cầu; ưu tiên người đến đo sức khỏe, khách mua thuốc cảm, tiêu hóa, da.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to)+" · phiếu mua sản phẩm chính dùng trong 14 ngày",
    bang:{head:["Hạng mục","Nội dung"],rows:[
      ["Số mẫu", mauN+" mẫu"+(giaMau?" · giá vốn "+vnd(giaMau)+"/mẫu nếu tự bỏ tiền":" · hãng tài trợ")],
      ["Kèm theo", "Phiếu giảm "+pct(giamPhieu,0)+" khi mua sản phẩm chính trong 14 ngày"],
      ["Ghi nhận", "Tên, SĐT, sản phẩm đã thử — nhắn hỏi thăm sau 5–7 ngày"],
      ["Dự kiến mua sau dùng thử", dung+" khách (12%) · đơn khoảng "+vnd(c.giaTPCN)]
    ]},
    dieuKien:["Chỉ phát mẫu TPCN, mỹ phẩm, thực phẩm còn hạn — không phát thuốc dùng thử.","Mỗi khách 1 mẫu mỗi loại; ghi tên, SĐT người nhận.","Hỏi tiền sử dị ứng trước khi cho thử mỹ phẩm, thực phẩm."],
    qua:[],
    kichBan:[{tinh:"Khi phát mẫu", noi:"Anh/chị dùng thử 3–5 ngày, em nhắn hỏi thăm. Thấy hợp thì mang phiếu này qua quầy được giảm "+pct(giamPhieu,0)+" hộp đầu."},
             {tinh:"Nhắn sau 5–7 ngày", noi:"Chào anh/chị, mẫu [sản phẩm] dùng thấy thế nào ạ? Phiếu giảm "+pct(giamPhieu,0)+" còn hạn đến [ngày], anh/chị cần em giữ hàng không ạ?"}],
    poster:{hl:"Dùng thử miễn phí — hợp mới mua", sub:"Nhận mẫu TPCN, mỹ phẩm tại quầy · Giảm "+pct(giamPhieu,0)+" khi mua sản phẩm chính"},
    zalo:"Chào anh/chị [Tên], mẫu [sản phẩm] anh/chị dùng thấy thế nào ạ? Phiếu giảm "+pct(giamPhieu,0)+" còn hạn đến [ngày]. Cần tư vấn thêm cứ nhắn quầy nhé.",
    kpi:[["Mẫu phát có ghi SĐT", "100%"],["Tỷ lệ mua sau dùng thử", "≥ 12%"],["Khách mới mua TPCN", "≥ "+dung]],
    chuanBi:["Xin hãng mẫu thử trước 2–3 tuần (xem phần giảm chi phí).","In phiếu giảm giá có hạn dùng.","Lập danh sách nhắn hỏi thăm (sheet 5 file Excel)."],
    chiPhi:0, cpLines:[{nhom:"mau", ten:"Mẫu dùng thử ("+mauN+" mẫu)", tien:mauN*giaMau},{nhom:"giam", ten:"Phiếu giảm khi mua sản phẩm chính", tien:dung*c.giaTPCN*giamPhieu}],
    dsTang:dung*c.giaTPCN*phan, laiGop:dung*c.giaTPCN*phan*c.bienTPCN,
    ds30:dung*c.giaTPCN*(1-phan), lai30:dung*c.giaTPCN*(1-phan)*c.bienTPCN,
    ds90:dung*0.5*c.giaTPCN, lai90:dung*0.5*c.giaTPCN*c.bienTPCN,
    moTaNgan:mauN+" mẫu · "+dung+" khách mua dự kiến"
  };
};

GEN.boctham = function(c) {
  const S = c.S || mauState();
  var Q=niceUp(c.A*2);
  var luot=Math.round(c.N*c.T*0.2*(c.has("khaitruong")?1.3:1));
  var hop=Math.max(1,Math.ceil(luot/100));
  var nhatSL=Math.ceil(hop/3);
  var cap=Q*c.bKM*0.12;
  /* cơ cấu mỗi thùng 100 phiếu: nhì, ba, khuyến khích, may mắn lần sau */
  var cauTruc=[[4,15,50,31],[3,12,50,35],[2,10,45,43],[1,6,43,50]];
  var target=[Q*4,Q*0.6,Q*0.2,Q*0.06];
  var tenGiai=["Giải nhất","Giải nhì","Giải ba","Khuyến khích"];
  var chosen=null, lines=null, ev=0, tongGiai=0, chiPhi=0;
  var snapshot=c.kho.map(function(k){return k.con;});
  for(var s=0;s<cauTruc.length;s++){
    c.kho.forEach(function(k,i){k.con=snapshot[i];});
    var ct=cauTruc[s], L=[];
    L.push(chonQua(c.kho, target[0], nhatSL, 0, tenGiai[0]));
    for(var i=0;i<3;i++) L.push(chonQua(c.kho, target[i+1], ct[i]*hop, 0, tenGiai[i+1]));
    var cost=L.reduce(function(a,l){return a+sumCost(l);},0) + ct[3]*hop*5000*0.3;
    chosen=ct; lines=L; chiPhi=cost; ev=cost/(hop*100);
    if(ev<=cap) break;
  }
  var soLuong=[nhatSL, chosen[0]*hop, chosen[1]*hop, chosen[2]*hop];
  var moTa=[nhatSL+" giải cả kỳ, bỏ ngẫu nhiên vào thùng", chosen[0]+" / 100 phiếu", chosen[1]+" / 100 phiếu", chosen[2]+" / 100 phiếu"];
  var rows=[];
  for(var j=0;j<4;j++){
    tongGiai+=lines[j].reduce(function(a,x){return a+x.sl*x.le;},0);
    rows.push([tenGiai[j], moTa[j], "<span class='giftcell'>"+esc(tenQua(lines[j]))+"</span>", vnd(lines[j][0].le), soLuong[j]+" giải"]);
  }
  rows.push(["May mắn lần sau", chosen[3]+" / 100 phiếu", "Phiếu 5.000đ cho hóa đơn sau", "5.000đ", (chosen[3]*hop)+" phiếu"]);
  tongGiai+=chosen[3]*hop*5000;
  var qua=[]; lines.forEach(function(l){ qua=qua.concat(l); });
  var nhat=tenQua(lines[0]);
  return {
    muc:"Tạo không khí và tiếng đồn trong khu vực, kéo khách mới tới quầy.",
    doiTuong:"Khách có hóa đơn từ "+vnd(Q)+".",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to),
    bang:{head:["Giải","Cơ cấu","Giải thưởng","Giá trị","Tổng cả kỳ ("+hop+" thùng)"],rows:rows},
    dieuKien:["Hóa đơn từ "+vnd(Q)+" được 1 lượt bốc, mỗi hóa đơn tối đa 3 lượt. "+LOAI_TRU_KM,
      "Mỗi thùng 100 phiếu theo cơ cấu trên, niêm phong và công khai cơ cấu giải. Bốc hết thùng mới mở thùng tiếp theo.",
      "Khách tự bốc trước mặt nhân viên và khách khác; ghi tên, số điện thoại người trúng vào sổ (sheet 5 file Excel).",
      "Tổng giá trị giải cả kỳ khoảng "+vnd(tongGiai)+(tongGiai>=1e8?" — TỪ 100 TRIỆU TRỞ LÊN, phải làm thủ tục với Sở Công Thương trước khi chạy.":" — dưới 100 triệu đồng."),
      "Giải nhất trao công khai, chụp ảnh đăng Zalo/Facebook khi khách đồng ý."],
    qua:qua, Q:Q, hop:hop, luot:luot, tongGiai:tongGiai, cauTruc:chosen,
    kichBan:[{tinh:"Khi thanh toán đủ điều kiện", noi:"Hóa đơn của anh/chị đủ "+kk(Q)+", mời anh/chị bốc một phiếu may mắn. Giải nhất là "+nhat.toLowerCase()+" đang trưng ở cửa đấy ạ."},
             {tinh:"Khách chưa đủ", noi:"Anh/chị thêm khoảng [x] nữa là được một lượt bốc thăm. Em chỉ gợi ý thêm món nhà mình đang cần thôi ạ."}],
    poster:{hl:"Mua từ "+kk(Q)+" — bốc thăm trúng quà", sub:"Giải nhất: "+nhat+" · "+(100-chosen[3])+"% phiếu có quà hiện vật"},
    zalo:"Chúc mừng anh/chị [Tên] đã trúng [giải] tại [Tên quầy]! Chương trình bốc thăm còn đến hết "+dmyy(c.to)+", hóa đơn từ "+vnd(Q)+" được 1 lượt bốc.",
    kpi:[["Lượt bốc", "≈ "+luot],["Chi phí mỗi lượt", "≤ "+vnd(cap)],["Khách mới trong kỳ", "tăng ≥ 20%"]],
    chuanBi:["In phiếu bốc thăm, gấp và niêm phong đủ "+hop+" thùng theo cơ cấu.","In thể lệ và cơ cấu giải khổ A3, dán cạnh thùng.","Trưng bày giải nhất ngay mặt tiền."],
    chiPhi:chiPhi, dsTang:c.DSky*0.08,
    evLuot:ev, capLuot:cap,
    moTaNgan:hop+" thùng phiếu, HĐ từ "+kk(Q)
  };
};

GEN.xahang = function(c) {
  const S = c.S || mauState();
  var rows=[], chiPhi=0, ds=0, thuHoi=0, items=[];
  c.kho.forEach(function(k){
    if(!k.laXa || k.con<=0) return;
    var h=k.hsd, co, gia, tyBan;
    if(h<=2){ co="Giảm 25% trực tiếp"; gia=k.le*0.75; tyBan=0.8; }
    else if(h<=4){ co = k.loai==="thuoc" ? "Giảm 15% trực tiếp" : "Mua 2 giảm 15%"; gia=k.le*0.85; tyBan=0.7; }
    else { co = k.loai==="thuoc" ? "Giảm 10% trực tiếp" : "Mua kèm hóa đơn từ "+kk(niceUp(c.A))+" giá ưu đãi"; gia=Math.max(k.von*1.02,k.le*0.85); tyBan=0.6; }
    gia=Math.round(gia/1000)*1000;
    var sl=Math.round(k.con*tyBan);
    rows.push(['<b>'+esc(k.ten)+'</b>'+(k.loai==="thuoc"?' <span class="tag warn">thuốc</span>':''), (h>=999?"—":h+" tháng"), k.con+"", co, vnd(k.le)+" → <b>"+vnd(gia)+"</b>", sl+"", vnd(sl*gia)+(gia<k.von?' <span class="tag bad">dưới vốn</span>':'')]);
    items.push({ten:k.ten, sl:k.con, co:co, gia:gia, von:k.von, le:k.le, ban:sl, hsd:h});
    chiPhi+=Math.max(0,sl*(k.von-gia));
    ds+=sl*gia; thuHoi+=sl*gia;
  });
  return {
    muc:"Thu hồi vốn đang nằm trên kệ trước khi hàng thành hàng hủy.",
    doiTuong:"Khách đúng nhu cầu với từng sản phẩm.",
    thoiGian:dmyy(c.from)+" – "+dmyy(c.to),
    bang: rows.length ? {head:["Sản phẩm","Hạn còn","Tồn còn lại","Cơ chế","Giá","Dự kiến bán","Thu về"],rows:rows}
      : {head:["Ghi chú"],rows:[["Chưa có dòng hàng nào chậm bán hoặc còn hạn dưới 6 tháng ở bước 3 (sau khi đã trừ phần dùng làm quà)."]]},
    dieuKien:["Kệ xả hàng ghi rõ hạn dùng từng sản phẩm, nhân viên nhắc hạn khi bán.","Thuốc chỉ giảm giá trực tiếp, không áp dụng mua nhiều giảm nhiều; chỉ bán khi đúng nhu cầu và khách dùng hết trước hạn.","Hàng xả giá không tính vào mốc hóa đơn và không cộng thêm ưu đãi khác.","Hàng còn dưới 1 tháng hạn: ngừng bán, trả nhà cung cấp hoặc hủy theo quy định."],
    qua:[], items:items, thuHoi:thuHoi,
    kichBan:[{tinh:"Giới thiệu hàng xả", noi:"Sản phẩm này quầy đang có giá tốt vì hạn dùng đến [tháng/năm]. Anh/chị dùng hết trong thời gian đó thì rất lợi ạ."}],
    poster:{hl:"Góc giá tốt — hàng còn hạn, giá mềm", sub:"Ghi rõ hạn dùng từng sản phẩm"},
    zalo:"[Tên quầy] đang có một số sản phẩm giá tốt (ghi rõ hạn dùng): [danh sách]. Anh/chị cần thì nhắn quầy giữ hàng nhé.",
    kpi:[["Tiền thu về", "≥ "+vnd(thuHoi)],["Hàng phải hủy cuối kỳ", "= 0"]],
    chuanBi:["Gom hàng xả về một kệ riêng, dán giá mới và hạn dùng.","Liên hệ nhà cung cấp hỏi chính sách đổi trả hàng cận hạn trước khi xả."],
    chiPhi:chiPhi, dsTang:ds,
    moTaNgan:items.length+" mã hàng xả"
  };
};



export /* Ma trận loại trừ */
function maTran(plans){
  var ids=plans.map(function(p){return p.id;});
  function rule(a,b){
    var k=[a,b].sort().join("|");
    var R={
      "moc|voucher":"Chọn 1: quà mốc hoặc phiếu lần sau",
      "boctham|moc": ids.indexOf("khaitruong")>=0 ? "Được cả hai trong 3 ngày khai trương, sau đó chọn 1" : "Chọn 1: quà mốc hoặc lượt bốc thăm",
      "boctham|voucher":"Được cả hai",
      "combo|moc":"Được cả hai — combo tính vào mốc theo giá sau ưu đãi",
      "combo|voucher":"Được cả hai",
      "gioithieu|voucher":"Không dùng hai phiếu trên cùng hóa đơn",
      "moc|xahang":"Hàng xả không tính vào mốc",
      "combo|xahang":"Không đưa hàng xả vào combo",
      "moc|trian":"Trong tuần tri ân dùng bảng mốc như cũ",
      "tichdiem|xahang":"Vẫn tích điểm trên số tiền thực trả",
      "combo|muanhieu":"Không cộng — sản phẩm đã giảm theo combo không giảm tiếp",
      "moc|muanhieu":"Được cả hai — tính mốc theo giá sau giảm",
      "muanhieu|voucher":"Được cả hai",
      "muanhieu|xahang":"Hàng xả không áp dụng mua nhiều",
      "dungthu|muanhieu":"Phiếu dùng thử chỉ áp cho hộp đầu, không cộng với giảm mua nhiều"
    };
    var t1=["ngayhoi","khaitruong","trian"];
    if(t1.indexOf(a)>=0 || t1.indexOf(b)>=0) return "Chạy song song — ưu đãi này là lý do mua hàng trong ngày sự kiện";
    if(R[k]) return R[k];
    if(a==="xahang"||b==="xahang") return "Hàng xả không cộng thêm ưu đãi";
    if(a==="tichdiem"||b==="tichdiem") return "Tích điểm trên số tiền thực trả";
    return "Được cả hai";
  }
  var out=[];
  for(var i=0;i<plans.length;i++) for(var j=i+1;j<plans.length;j++){
    out.push([plans[i].code+" "+plans[i].ten, plans[j].code+" "+plans[j].ten, rule(plans[i].id,plans[j].id)]);
  }
  return out;
}



export function lichTong(c,plans){
  var kt=c.has("khaitruong");
  var L=[
    [addDays(c.from,kt?-14:-7),"Chuẩn bị","Kiểm hạn dùng và số lượng quà, mua bổ sung quà còn thiếu; chọn sản phẩm thật cho combo; đặt in poster, thể lệ, phiếu."],
    [addDays(c.from,kt?-10:-5),"Đào tạo","Họp nhân viên 30 phút: đọc thể lệ, tập câu nói từng tình huống, phân công người giữ quà và sổ phiếu."],
    [addDays(c.from,kt?-7:-3),"Truyền thông","Dán poster, treo băng rôn; gửi tin Zalo; đăng Facebook, cập nhật ảnh lên Google Maps."],
    [c.from,"Bắt đầu","Chạy chương trình. Cuối mỗi ngày ghi sheet 4 (nhật ký ngày) và sheet 5 (phát quà)."],
    [addDays(c.from,Math.max(2,Math.floor(c.T/2)-1)),"Rà giữa kỳ","Xem giá trị hóa đơn trung bình, quà còn lại, phiếu đã dùng. Quà sắp hết thì bổ sung hoặc đổi quà tương đương."],
    [c.to,"Kết thúc","Gỡ poster, thông báo kết thúc trên Zalo. Chốt số quà còn lại."],
    [addDays(c.to,3),"Nghiệm thu","Mở sheet 8: so sánh trước và trong chương trình, quyết định giữ, chỉnh hay dừng cho kỳ sau."]
  ];
  if(c.has("voucher")) L.push([addDays(c.to,7),"Nhắc phiếu","Nhắn Zalo khách còn phiếu chưa dùng, trước hạn 3 ngày."]);
  if(c.ev){
    L.push([addDays(c.from,-21),"Xin hỗ trợ","Gửi đề nghị đồng hành cho 2–3 hãng (bàn tư vấn, mẫu thử, quà, standee) và nhà phân phối đang lấy hàng."]);
    L.push([addDays(c.from,-14),"Phường, hội","Nộp đề nghị phát thanh, treo phướn cho phường; mời hội người cao tuổi, hội phụ nữ; liên hệ trường nếu cần sinh viên."]);
    L.push([addDays(c.from,-7),"Chốt nguồn lực","Chốt hãng tham gia, số mẫu, số người trực; dược sĩ duyệt bảng gợi ý sau đo."]);
    L.push([addDays(c.from,-1),"Nhắc khách","Phát thanh lần 2, nhắn nhóm Zalo, gọi khách quen người cao tuổi."]);
    L.push([addDays(c.to,5),"Chăm sóc sau sự kiện","Nhắn hỏi thăm người đã đo và nhận mẫu; gửi hãng báo cáo lượt tư vấn, số đơn."]);
  }
  return L.sort(function(a,b){return a[0]-b[0];});
}



export function canhBao(r) {
  const S = r.S || r.ctx?.S || mauState();
  var c=r.ctx, A=[];
  var tyTang=r.dsTang/c.DSky;
  if(r.chiPhi>r.ns*1.05) A.push(["bad","Vượt ngân sách","Chi phí dự kiến "+tr(r.chiPhi)+" vượt ngân sách "+tr(r.ns)+". Xin thêm hỗ trợ ở phần giảm chi phí, bỏ bớt một chương trình nhỏ hoặc hạ mốc quà."]);
  if(r.hs3<1) A.push(["bad","Lỗ kể cả tính khách quay lại","Tính cả 90 ngày, mỗi 1đ chi phí chỉ mang về "+r.hs3.toFixed(2).replace(".",",")+"đ lãi gộp. Cắt chi phí hoặc đổi chương trình."]);
  else if(r.hs<1) A.push(["warn","Hòa vốn trong kỳ, lời nhờ khách quay lại","Trong kỳ 1đ chi phí mang về "+r.hs.toFixed(2).replace(".",",")+"đ lãi gộp; tính đủ 90 ngày là "+r.hs3.toFixed(2).replace(".",",")+"đ. Bắt buộc lưu SĐT, Zalo người tham gia để chăm sóc lại."]);
  else if(r.hs3<1.5) A.push(["warn","Hiệu quả mỏng","Tính đủ 90 ngày, 1đ chi phí mang về "+r.hs3.toFixed(2).replace(".",",")+"đ lãi gộp. Nên đạt từ 1,5đ trở lên."]);
  if(tyTang < c.g*0.9) A.push(["warn","Chưa tới mục tiêu","Dự kiến tăng "+pct(tyTang,0)+" doanh số trong kỳ, thấp hơn mục tiêu "+pct(c.g,0)+". "+(c.ev?"Thêm ngày cao điểm, thêm người trực đo hoặc xin hãng cử người tư vấn.":"Thêm một chương trình tổng quan để kéo khách.")]);
  if(S.ct.length>4) A.push(["warn","Quá nhiều chương trình nhỏ",S.ct.length+" chương trình nhỏ cùng lúc khiến khách khó hiểu, nhân viên khó nhớ. Nên giữ 2–3."]);
  if(c.ev && !S.ct.length) A.push(["warn","Sự kiện chưa có lý do mua hàng","Khách vào đo sức khỏe nhưng không có ưu đãi để mua. Chọn thêm combo hoặc mua nhiều giảm giá."]);
  if(r.ev && r.ev.pheu && r.ev.pheu.doOn && r.ev.pheu.muonDo>r.ev.pheu.cap) A.push(["warn","Thiếu người trực đo","Dự kiến "+r.ev.pheu.muonDo+" người muốn đo nhưng "+r.ev.pheu.nguoi+" người chỉ đo được "+r.ev.pheu.cap+" lượt. Thêm người hoặc xin sinh viên, hãng hỗ trợ."]);
  if(c.ev && !S.hoTro.some(function(id){var h=hoTroOf(id); return h && h.suKien;})){
    var best=r.giamChiPhi.filter(function(x){return !x.on;}).sort(function(a,b){return b.tietKiem-a.tietKiem;})[0];
    A.push(["warn","Chưa xin hỗ trợ cho sự kiện","Xem phần giảm chi phí bên dưới"+(best&&best.tietKiem>0?" — riêng \""+best.h.ten+"\" có thể giảm khoảng "+tr(best.tietKiem):"")+"."]);
  }
  if(c.ev){
    var homNay=new Date(); homNay.setHours(0,0,0,0);
    var conNgay=Math.round((c.from-homNay)/86400000);
    if(conNgay<21) A.push(["warn","Còn "+Math.max(0,conNgay)+" ngày chuẩn bị","Hãng thường cần 2–3 tuần để duyệt người, mẫu thử; phường cần 7–10 ngày. Liên hệ ngay hôm nay hoặc lùi ngày bắt đầu."]);
  }
  if(c.m.tyRx>0.4) A.push(["warn","Thuốc kê đơn chiếm "+pct(c.m.tyRx,0),"Phần lớn doanh thu không được tính mốc hay tích điểm. Ưu tiên đo sức khỏe, combo và mua nhiều TPCN."]);
  if(c.m.bienTB>0 && c.m.bienTB<0.15) A.push(["warn","Biên lãi thấp","Biên bình quân "+pct(c.m.bienTB)+" — hạn chế giảm giá, ưu tiên quà hãng tặng và hàng chậm bán."]);
  if(Math.abs(c.m.tong-100)>0.5) A.push(["warn","Tỷ trọng chưa đủ 100%","Tổng tỷ trọng nhóm hàng đang là "+pct(c.m.tong/100,0)+"; tool đã tự quy về 100%."]);
  var mua={}; r.plans.forEach(function(p){ (p.qua||[]).forEach(function(l){ if(l.nguon==="mua" && l.sl>0){ mua[l.ten]=(mua[l.ten]||0)+l.sl; } }); });
  var ks=Object.keys(mua);
  if(ks.length) A.push(["warn","Cần thêm quà",ks.map(function(k){return k+": "+mua[k];}).join(" · ")+". Xin hãng, nhà phân phối tài trợ trước khi tự mua."]);
  r.plans.forEach(function(p){
    if(p.id==="boctham" && p.tongGiai>=1e8) A.push(["bad","Bốc thăm từ 100 triệu","Tổng giá trị giải "+tr(p.tongGiai)+" — phải làm thủ tục với Sở Công Thương trước khi chạy."]);
    if(p.id==="boctham" && p.evLuot>p.capLuot*1.05) A.push(["warn","Giải bốc thăm đắt","Chi phí mỗi lượt "+vnd(p.evLuot)+" cao hơn mức nên có "+vnd(p.capLuot)+". Thêm quà hãng tặng vào cơ cấu giải."]);
  });
  if(c.has("moc") && c.T>45) A.push(["warn","Mốc quà kéo dài","Chạy mốc quà quá 45 ngày khách sẽ quen, hết tác dụng. Chia thành 2 đợt với quà khác nhau."]);
  var huy=c.kho.filter(function(k){return k.huy;});
  if(huy.length) A.push(["bad","Hàng dưới 1 tháng hạn",huy.map(function(k){return k.ten;}).join(", ")+" — không dùng làm quà, không xả. Trả nhà cung cấp hoặc hủy."]);
  if(S.qua.some(function(q){return q.ten && q.loai==="thuoc";})) A.push(["ok","Đã loại thuốc khỏi quà","Thuốc chỉ được đưa vào phần xả hàng, không dùng làm quà hay dùng thử."]);
  if(!A.some(function(a){return a[0]!=="ok";})) A.unshift(["ok","Ổn","Chi phí nằm trong ngân sách và hiệu quả dự kiến đạt."]);
  return A;
}


export function lapKeHoach(S) {
  if (!S) return null;
  var m=tinhNhom(S.nhom || []);
  var D=num(S.dsNgay)*1e6, A=num(S.donGia)*1000, T=Math.max(1,Math.round(num(S.soNgay)||1));
  if(D<=0||A<=0) return null;
  var N0=D/A, DSky=D*T, g=num(S.mucTieu)/100;
  var from=parseISO(S.batDau), to=addDays(from,T-1);
  var ev=S.tongQuan||"";
  var has=function(id){return S.ct.indexOf(id)>=0 || ev===id;};
  var zalo = S.kenh.indexOf("zalo")>=0 || S.kenh.indexOf("oa")>=0;
  var bKM = m.bienKM || m.bienTB || 0.2;
  var pf=S.pheu||{};
  var evDays = !ev ? 0 : ev==="khaitruong" ? clamp(Math.round(num(pf.ngaySK)||3), 1, Math.min(7, T)) : clamp(Math.round(num(pf.ngaySK)||2), 1, T);
  var hBase={ngayhoi:1.5, khaitruong:2.0, trian:1.3}[ev]||1;
  var adj={tp:-0.1, tinh:0, thitran:0.15, nongthon:0.2, kcn:0}[S.khuVuc]||0;
  var bonus=0; if(ev) S.hoTro.forEach(function(id){ var h=hoTroOf(id); if(h&&h.traffic) bonus+=h.traffic; });
  var h = ev ? hBase+adj+bonus : 1;
  var extra = ev ? N0*(h-1)*evDays : 0;
  var N = N0*(1+extra/(N0*T));
  var crBase={quay:0.15, hang:0.22, chuyengia:0.28}[pf.tuVan]||0.15;
  if(S.hoTro.indexOf("hang_ban")>=0 && pf.tuVan==="quay") crBase+=0.07;

  var nsSmall = DSky*(1+g)*m.tyKM*0.2*bKM;
  var nsEv = ev ? D*evDays*h*0.18 + (ev==="khaitruong"? D*evDays*0.05 : 0) : 0;
  var nsNhap = num(S.nganSach)*1e6;
  var nsDeXuat = nsSmall+nsEv;
  var ns = nsNhap>0 ? nsNhap : nsDeXuat;
  var sumW=0; S.ct.forEach(function(id){ var p=progOf(id); if(p) sumW+=p.w; });

  var ctx={m:m,D:D,A:A,N:N,N0:N0,T:T,DSky:DSky,g:g,from:from,to:to,has:has,zalo:zalo,bKM:bKM,ns:ns,sumW:sumW,
    kho:taoKho(T, S),month:from.getMonth()+1, S: S, ev:ev, evDays:evDays, h:h, extra:extra, cr:crBase,
    giaTPCN:(num(pf.giaTPCN)||300)*1000, bienTPCN:bienTPCNOf(m, S), pf:pf};
  var order=["khaitruong","trian","ngayhoi","moc","combo","muanhieu","dungthu","voucher","tichdiem","gioithieu","boctham","xahang"];
  var plans=[], stt=0;
  order.forEach(function(id){
    if(!has(id)) return;
    var p=GEN[id](ctx); stt++;
    p.id=id; p.code="CT"+String(stt).padStart(2,"0");
    var meta=progOf(id);
    p.ten=p.ten||meta.ten; p.donbay=meta.donbay; p.tang=meta.tang;
    p.nganSach = meta.tang===1 ? (nsNhap>0 ? ns*nsEv/nsDeXuat : nsEv) : (sumW? (nsNhap>0 ? ns*nsSmall/nsDeXuat : nsSmall)*meta.w/sumW : 0);
    p.chiPhiGoc0 = p.chiPhi;
    p.cpLines = dongChiPhi(p);
    p.chiPhiGoc = p.cpLines.reduce(function(a,l){return a+l.tien;},0);
    p.chiPhi = chiPhiVoi([p], S.hoTro);
    if(p.laiGop==null) p.laiGop = p.dsTang*bKM;
    p.ds30=p.ds30||0; p.ds90=p.ds90||0;
    if(p.lai30==null) p.lai30=p.ds30*bKM;
    if(p.lai90==null) p.lai90=p.ds90*bKM;
    plans.push(p);
  });
  var sum=function(k){ return plans.reduce(function(a,p){return a+(p[k]||0);},0); };
  var res={ctx:ctx, S: S, plans:plans, ns:ns, nsDeXuat:nsDeXuat, nsNhap:nsNhap,
    chiPhi:sum("chiPhi"), chiPhiGoc:sum("chiPhiGoc"),
    dsTang:sum("dsTang"), ds30:sum("ds30"), ds90:sum("ds90"),
    lai:sum("laiGop"), lai30:sum("lai30"), lai90:sum("lai90")};
  res.laiTang = res.lai - res.chiPhi;
  res.lai3 = res.lai + res.lai30 + res.lai90 - res.chiPhi;
  res.hs = res.chiPhi>0 ? res.lai/res.chiPhi : 0;
  res.hs3 = res.chiPhi>0 ? (res.lai+res.lai30+res.lai90)/res.chiPhi : 0;
  res.ev = plans.filter(function(p){return p.tang===1;})[0]||null;
  res.giamChiPhi = HOTRO.map(function(hh){
    var on=S.hoTro.indexOf(hh.id)>=0;
    var withSet = on ? S.hoTro : S.hoTro.concat([hh.id]);
    var without = S.hoTro.filter(function(x){return x!==hh.id;});
    var tk = chiPhiVoi(plans, without) - chiPhiVoi(plans, withSet);
    return {h:hh, on:on, tietKiem:tk, lienQuan: tk>1000 || (hh.suKien && !!ev) || (!!hh.traffic && !!ev) || (hh.cr && !!ev)};
  });
  res.matran=maTran(plans);
  res.lich=lichTong(ctx,plans);
  res.canhBao=canhBao(res);
  res.huy=ctx.kho.filter(function(k){return k.huy;});
  return res;
}



/* ===================== XUẤT VĂN BẢN TỔNG HỢP ===================== */
export function vanBan(r, storeName = "") {
  if (!r) return "";
  var tenQuayLead = storeName || r.S?.tenQuay || "";
  var c=r.ctx, L=[];
  var strip=function(s){ return String(s).replace(/<br>/g," / ").replace(/<[^>]+>/g,"").replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"'); };
  L.push("CHƯƠNG TRÌNH BÁN HÀNG "+(tenQuayLead?"— "+tenQuayLead.toUpperCase():""));
  L.push("Thời gian: "+dmyy(c.from)+" – "+dmyy(c.to)+" · Ngân sách "+tr(r.ns)+" · Chi phí dự kiến "+tr(r.chiPhi)+" · Doanh số tăng trong kỳ "+tr(r.dsTang)+" · 30 ngày sau "+tr(r.ds30)+" · 90 ngày "+tr(r.ds90));
  r.plans.forEach(function(p){
    L.push(""); L.push(p.code+". "+p.ten.toUpperCase()); L.push("Thời gian: "+p.thoiGian); L.push("Mục tiêu: "+p.muc);
    L.push("Cơ chế:"); p.bang.rows.forEach(function(row){ L.push("  - "+row.map(strip).join(" | ")); });
    L.push("Thể lệ:"); p.dieuKien.forEach(function(x){L.push("  - "+x);});
    L.push("Câu nói nhân viên:"); p.kichBan.forEach(function(k){L.push("  - "+k.tinh+": "+k.noi);});
    L.push("Tin Zalo:"); L.push(p.zalo);
  });
  L.push(""); L.push("GIẢI PHÁP GIẢM CHI PHÍ");
  r.giamChiPhi.filter(function(x){return x.on||x.lienQuan;}).forEach(function(x){ L.push("  - "+(x.on?"[Đã chọn] ":"")+x.h.ten+(x.tietKiem>0?" — giảm khoảng "+tr(x.tietKiem):"")); });
  if(r.matran.length){ L.push(""); L.push("QUY TẮC CỘNG DỒN"); r.matran.forEach(function(x){L.push("  - "+x[0]+" + "+x[1]+": "+x[2]);}); }
  L.push(""); L.push("LỊCH TRIỂN KHAI"); r.lich.forEach(function(l){L.push("  "+dmy(l[0])+" · "+l[1]+": "+l[2]);});
  return L.join("\n");
}


/* ===================== BỘ TẠO FILE EXCEL 10 SHEET ===================== */
/* ===================== BỘ TẠO XLSX (JS thuần, không thư viện) ===================== */
var XL=(function(){
  var CRC=(function(){var t=[];for(var n=0;n<256;n++){var c=n;for(var k=0;k<8;k++)c=c&1?0xEDB88320^(c>>>1):c>>>1;t[n]=c>>>0;}return t;})();
  function crc32(u){var c=0xFFFFFFFF;for(var i=0;i<u.length;i++)c=CRC[(c^u[i])&0xFF]^(c>>>8);return (c^0xFFFFFFFF)>>>0;}
  var enc=new TextEncoder();
  var CTRL=new RegExp("[\\x00-\\x08\\x0B\\x0C\\x0E-\\x1F]","g");
  function zip(files){
    var parts=[],central=[],off=0,now=new Date();
    var dt=((now.getHours()<<11)|(now.getMinutes()<<5)|(now.getSeconds()>>1))&0xFFFF, dd=(((now.getFullYear()-1980)<<9)|((now.getMonth()+1)<<5)|now.getDate())&0xFFFF;
    files.forEach(function(f){
      var name=enc.encode(f.name), data=enc.encode(f.data), crc=crc32(data);
      var h=new DataView(new ArrayBuffer(30));
      h.setUint32(0,0x04034b50,true);h.setUint16(4,20,true);h.setUint16(6,0x0800,true);h.setUint16(8,0,true);
      h.setUint16(10,dt,true);h.setUint16(12,dd,true);h.setUint32(14,crc,true);h.setUint32(18,data.length,true);h.setUint32(22,data.length,true);
      h.setUint16(26,name.length,true);h.setUint16(28,0,true);
      parts.push(new Uint8Array(h.buffer),name,data);
      var c=new DataView(new ArrayBuffer(46));
      c.setUint32(0,0x02014b50,true);c.setUint16(4,20,true);c.setUint16(6,20,true);c.setUint16(8,0x0800,true);c.setUint16(10,0,true);
      c.setUint16(12,dt,true);c.setUint16(14,dd,true);c.setUint32(16,crc,true);c.setUint32(20,data.length,true);c.setUint32(24,data.length,true);
      c.setUint16(28,name.length,true);c.setUint16(30,0,true);c.setUint16(32,0,true);c.setUint16(34,0,true);c.setUint16(36,0,true);c.setUint32(38,0,true);c.setUint32(42,off,true);
      central.push(new Uint8Array(c.buffer),name);
      off+=30+name.length+data.length;
    });
    var cs=central.reduce(function(a,b){return a+b.length;},0);
    var e=new DataView(new ArrayBuffer(22));
    e.setUint32(0,0x06054b50,true);e.setUint16(8,files.length,true);e.setUint16(10,files.length,true);e.setUint32(12,cs,true);e.setUint32(16,off,true);
    var all=parts.concat(central,[new Uint8Array(e.buffer)]);
    var len=all.reduce(function(a,b){return a+b.length;},0), out=new Uint8Array(len), p=0;
    all.forEach(function(b){out.set(b,p);p+=b.length;});
    return out;
  }
  function x(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(CTRL,"");}
  function col(i){var s="";i++;while(i>0){var m=(i-1)%26;s=String.fromCharCode(65+m)+s;i=Math.floor((i-1)/26);}return s;}
  var ST={def:0,title:1,head:2,txt:3,money:4,pct:5,date:6,inTxt:7,inMoney:8,inPct:9,inDate:10,note:11,totMoney:12,totTxt:13,sec:14,bold:15,inInt:8,int:4,totPct:16};
  var styles='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><styleSheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main">'+
   '<numFmts count="3"><numFmt numFmtId="164" formatCode="#,##0"/><numFmt numFmtId="165" formatCode="0.0%"/><numFmt numFmtId="166" formatCode="dd/mm/yyyy"/></numFmts>'+
   '<fonts count="6"><font><sz val="10"/><name val="Arial"/></font><font><b/><sz val="16"/><color rgb="FF005B31"/><name val="Arial"/></font><font><b/><sz val="10"/><color rgb="FFFFFFFF"/><name val="Arial"/></font><font><i/><sz val="9"/><color rgb="FF5B6A61"/><name val="Arial"/></font><font><b/><sz val="10"/><name val="Arial"/></font><font><b/><sz val="12"/><color rgb="FF005B31"/><name val="Arial"/></font></fonts>'+
   '<fills count="5"><fill><patternFill patternType="none"/></fill><fill><patternFill patternType="gray125"/></fill><fill><patternFill patternType="solid"><fgColor rgb="FF005B31"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFFFF7CC"/></patternFill></fill><fill><patternFill patternType="solid"><fgColor rgb="FFDCEEE2"/></patternFill></fill></fills>'+
   '<borders count="2"><border><left/><right/><top/><bottom/><diagonal/></border><border><left style="thin"><color rgb="FFC9D3CB"/></left><right style="thin"><color rgb="FFC9D3CB"/></right><top style="thin"><color rgb="FFC9D3CB"/></top><bottom style="thin"><color rgb="FFC9D3CB"/></bottom><diagonal/></border></borders>'+
   '<cellStyleXfs count="1"><xf numFmtId="0" fontId="0" fillId="0" borderId="0"/></cellStyleXfs><cellXfs count="17">'+
   '<xf numFmtId="0" fontId="0" fillId="0" borderId="0" xfId="0"/>'+
   '<xf numFmtId="0" fontId="1" fillId="0" borderId="0" xfId="0" applyFont="1"/>'+
   '<xf numFmtId="0" fontId="2" fillId="2" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment vertical="center" wrapText="1"/></xf>'+
   '<xf numFmtId="0" fontId="0" fillId="0" borderId="1" xfId="0" applyBorder="1" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>'+
   '<xf numFmtId="164" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1" applyAlignment="1"><alignment vertical="top"/></xf>'+
   '<xf numFmtId="165" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1" applyAlignment="1"><alignment vertical="top"/></xf>'+
   '<xf numFmtId="166" fontId="0" fillId="0" borderId="1" xfId="0" applyNumberFormat="1" applyBorder="1" applyAlignment="1"><alignment horizontal="left" vertical="top"/></xf>'+
   '<xf numFmtId="0" fontId="0" fillId="3" borderId="1" xfId="0" applyFill="1" applyBorder="1" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>'+
   '<xf numFmtId="164" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/>'+
   '<xf numFmtId="165" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1"/>'+
   '<xf numFmtId="166" fontId="0" fillId="3" borderId="1" xfId="0" applyNumberFormat="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment horizontal="left"/></xf>'+
   '<xf numFmtId="0" fontId="3" fillId="0" borderId="0" xfId="0" applyFont="1"/>'+
   '<xf numFmtId="164" fontId="4" fillId="4" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
   '<xf numFmtId="0" fontId="4" fillId="4" borderId="1" xfId="0" applyFont="1" applyFill="1" applyBorder="1" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>'+
   '<xf numFmtId="0" fontId="5" fillId="4" borderId="0" xfId="0" applyFont="1" applyFill="1"/>'+
   '<xf numFmtId="0" fontId="4" fillId="0" borderId="1" xfId="0" applyFont="1" applyBorder="1" applyAlignment="1"><alignment vertical="top" wrapText="1"/></xf>'+
   '<xf numFmtId="165" fontId="4" fillId="4" borderId="1" xfId="0" applyNumberFormat="1" applyFont="1" applyFill="1" applyBorder="1"/>'+
   '</cellXfs><cellStyles count="1"><cellStyle name="Normal" xfId="0" builtinId="0"/></cellStyles>'+
   '<dxfs count="3"><dxf><font><b/><color rgb="FFB3261E"/></font><fill><patternFill><bgColor rgb="FFFBE6E4"/></patternFill></fill></dxf><dxf><font><b/><color rgb="FF8A5A00"/></font><fill><patternFill><bgColor rgb="FFFDF1D6"/></patternFill></fill></dxf><dxf><font><b/><color rgb="FF1E6B3A"/></font><fill><patternFill><bgColor rgb="FFE0F1E6"/></patternFill></fill></dxf></dxfs>'+
   '</styleSheet>';
  function cellXml(v,ref){
    if(v===null||v===undefined) return "";
    var o=(typeof v==="object")?v:{v:v};
    var s=o.s!=null?(typeof o.s==="string"?ST[o.s]:o.s):(typeof o.v==="number"?ST.money:0);
    var sa=s?' s="'+s+'"':'';
    if(o.f!=null) return '<c r="'+ref+'"'+sa+'><f>'+x(o.f)+'</f></c>';
    if(o.v===null||o.v===undefined||o.v==="") return s?'<c r="'+ref+'"'+sa+'/>':'';
    if(typeof o.v==="number") return '<c r="'+ref+'"'+sa+'><v>'+o.v+'</v></c>';
    return '<c r="'+ref+'"'+sa+' t="inlineStr"><is><t xml:space="preserve">'+x(o.v)+'</t></is></c>';
  }
  function sheetXml(sh){
    var h='<?xml version="1.0" encoding="UTF-8" standalone="yes"?><worksheet xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships">';
    h+='<sheetViews><sheetView workbookViewId="0" showGridLines="0"'+(sh.tab?' tabSelected="1"':'')+'>';
    if(sh.freeze) h+='<pane ySplit="'+sh.freeze+'" topLeftCell="A'+(sh.freeze+1)+'" activePane="bottomLeft" state="frozen"/>';
    h+='</sheetView></sheetViews><sheetFormatPr defaultRowHeight="15"/>';
    if(sh.cols) h+='<cols>'+sh.cols.map(function(w,i){return '<col min="'+(i+1)+'" max="'+(i+1)+'" width="'+w+'" customWidth="1"/>';}).join("")+'</cols>';
    h+='<sheetData>';
    sh.rows.forEach(function(r,ri){
      if(!r) return;
      var cells=r.map(function(v,ci){return cellXml(v,col(ci)+(ri+1));}).join("");
      var ht=sh.heights&&sh.heights[ri]?' ht="'+sh.heights[ri]+'" customHeight="1"':'';
      if(cells||ht) h+='<row r="'+(ri+1)+'"'+ht+'>'+cells+'</row>';
    });
    h+='</sheetData>';
    if(sh.merges&&sh.merges.length) h+='<mergeCells count="'+sh.merges.length+'">'+sh.merges.map(function(m){return '<mergeCell ref="'+m+'"/>';}).join("")+'</mergeCells>';
    (sh.cf||[]).forEach(function(c,i){
      h+='<conditionalFormatting sqref="'+c.ref+'">'+c.rules.map(function(r,j){return '<cfRule type="containsText" dxfId="'+r.dxf+'" priority="'+(i*10+j+1)+'" operator="containsText" text="'+x(r.text)+'"><formula>NOT(ISERROR(SEARCH("'+x(r.text)+'",'+c.ref.split(":")[0]+')))</formula></cfRule>';}).join("")+'</conditionalFormatting>';
    });
    if(sh.dv&&sh.dv.length) h+='<dataValidations count="'+sh.dv.length+'">'+sh.dv.map(function(d){return '<dataValidation type="list" allowBlank="1" showErrorMessage="0" sqref="'+d.ref+'"><formula1>'+x(d.f)+'</formula1></dataValidation>';}).join("")+'</dataValidations>';
    h+='<pageMargins left="0.4" right="0.4" top="0.5" bottom="0.5" header="0.3" footer="0.3"/><pageSetup paperSize="9" orientation="landscape"/>';
    return h+'</worksheet>';
  }
  function build(sheets){
    var f=[];
    f.push({name:"[Content_Types].xml",data:'<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Types xmlns="http://schemas.openxmlformats.org/package/2006/content-types"><Default Extension="rels" ContentType="application/vnd.openxmlformats-package.relationships+xml"/><Default Extension="xml" ContentType="application/xml"/><Override PartName="/xl/workbook.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml"/><Override PartName="/xl/styles.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml"/>'+sheets.map(function(s,i){return '<Override PartName="/xl/worksheets/sheet'+(i+1)+'.xml" ContentType="application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml"/>';}).join("")+'</Types>'});
    f.push({name:"_rels/.rels",data:'<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships"><Relationship Id="rId1" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument" Target="xl/workbook.xml"/></Relationships>'});
    f.push({name:"xl/workbook.xml",data:'<?xml version="1.0" encoding="UTF-8" standalone="yes"?><workbook xmlns="http://schemas.openxmlformats.org/spreadsheetml/2006/main" xmlns:r="http://schemas.openxmlformats.org/officeDocument/2006/relationships"><bookViews><workbookView activeTab="0"/></bookViews><sheets>'+sheets.map(function(s,i){return '<sheet name="'+x(s.name)+'" sheetId="'+(i+1)+'" r:id="rId'+(i+1)+'"/>';}).join("")+'</sheets><calcPr calcId="191029" fullCalcOnLoad="1"/></workbook>'});
    f.push({name:"xl/_rels/workbook.xml.rels",data:'<?xml version="1.0" encoding="UTF-8" standalone="yes"?><Relationships xmlns="http://schemas.openxmlformats.org/package/2006/relationships">'+sheets.map(function(s,i){return '<Relationship Id="rId'+(i+1)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet" Target="worksheets/sheet'+(i+1)+'.xml"/>';}).join("")+'<Relationship Id="rId'+(sheets.length+1)+'" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles" Target="styles.xml"/></Relationships>'});
    f.push({name:"xl/styles.xml",data:styles});
    sheets.forEach(function(s,i){f.push({name:"xl/worksheets/sheet"+(i+1)+".xml",data:sheetXml(s)});});
    return zip(f);
  }
  return {build:build, col:col};
})();
/* ===================== NỘI DUNG FILE EXCEL ===================== */
function serial(d){ return Math.round((Date.UTC(d.getFullYear(),d.getMonth(),d.getDate())-Date.UTC(1899,11,30))/86400000); }
function stripHtml(s){ return String(s).replace(/<br>/g," / ").replace(/<[^>]+>/g,"").replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&quot;/g,'"'); }
var SN={tq:"'1.TONG QUAN'", ct:"'2.CHUONG TRINH'", kho:"'3.KHO QUA'", nk:"'4.NHAT KY NGAY'", pq:"'5.PHAT QUA'", ph:"'6.PHIEU'", tv:"'7.THANH VIEN'", nt:"'8.NGHIEM THU'"};

export function taoWorkbook(r, storeName = "") {
  if (!r) return null;
  var S = r.S || r.ctx?.S || mauState();
  var tenQuayLead = storeName || S.tenQuay || "";
  var c=r.ctx, P=r.plans, ten=tenQuayLead||"[Tên quầy]";
  var tenOf=function(list,id){ var o=list.filter(function(x){return x.id===id;})[0]; return o?o.ten:""; };
  var sheets=[];

  /* ---- 1. TỔNG QUAN ---- */
  var R=[];
  R[0]=[{v:"CHƯƠNG TRÌNH BÁN HÀNG — "+ten.toUpperCase(),s:"title"}];
  R[1]=[{v:"Ô nền vàng sửa được. Các sheet khác lấy số từ sheet này. Tạo bởi Cẩm nang xây chương trình bán hàng nhà thuốc x2 doanh số — Trung tâm công cụ thực chiến cho nhà thuốc, ngày "+dmyy(new Date())+".",s:"note"}];
  R[3]=[{v:"THAM SỐ QUẦY",s:"sec"},{v:"",s:"sec"},null,{v:"BỐI CẢNH",s:"sec"},{v:"",s:"sec"}];
  R[4]=[{v:"Doanh số trung bình/ngày trước chương trình (đ)",s:"txt"},{v:c.D,s:"inMoney"},null,{v:"Tên quầy",s:"txt"},{v:ten,s:"inTxt"}];
  R[5]=[{v:"Giá trị trung bình 1 hóa đơn trước chương trình (đ)",s:"txt"},{v:c.A,s:"inMoney"},null,{v:"Khu vực",s:"txt"},{v:tenOf(LIB.khuVuc,S.khuVuc),s:"txt"}];
  R[6]=[{v:"Số hóa đơn/ngày",s:"txt"},{f:"IF(B6>0,B5/B6,0)",s:"money"},null,{v:"Vị trí",s:"txt"},{v:tenOf(LIB.viTri,S.viTri),s:"txt"}];
  R[7]=[{v:"Biên lãi gộp nhóm được khuyến mại",s:"txt"},{v:Math.round(c.bKM*10000)/10000,s:"inPct"},null,{v:"Loại hình",s:"txt"},{v:tenOf(LIB.loaiHinh,S.loaiHinh),s:"txt"}];
  R[8]=[{v:"Ngày bắt đầu",s:"txt"},{v:serial(c.from),s:"inDate"},null,{v:"Tệp khách chính",s:"txt"},{v:S.tep.map(function(t){return tenOf(LIB.tep,t);}).join(", "),s:"txt"}];
  R[9]=[{v:"Số ngày chạy",s:"txt"},{v:c.T,s:"inMoney"},null,{v:"Kênh nhắn khách",s:"txt"},{v:S.kenh.map(function(t){return tenOf(LIB.kenh,t);}).join(", "),s:"txt"}];
  R[10]=[{v:"Ngày kết thúc",s:"txt"},{f:"B9+B10-1",s:"date"}];
  R[11]=[{v:"Ngân sách chương trình (đ)",s:"txt"},{v:Math.round(r.ns),s:"inMoney"}];
  R[12]=[{v:"Mục tiêu tăng doanh số",s:"txt"},{v:c.g,s:"inPct"}];
  R[13]=[{v:"Doanh số kỳ nếu không chạy (đ)",s:"txt"},{f:"B5*B10",s:"money"}];
  R[14]=[{v:"Doanh số kỳ mục tiêu (đ)",s:"txt"},{f:"B14*(1+B13)",s:"money"}];
  R[15]=[{v:"Biên lãi gộp bình quân cả quầy",s:"txt"},{v:Math.round(c.m.bienTB*10000)/10000,s:"pct"}];
  R[17]=[{v:"DANH SÁCH CHƯƠNG TRÌNH",s:"sec"}];
  R[18]=["Mã","Chương trình","Đòn bẩy","Cơ chế chính","Ngân sách phân bổ (đ)","Chi phí dự kiến (đ)","Doanh số tăng dự kiến (đ)","Chi phí thực tế (đ)"].map(function(h){return {v:h,s:"head"};});
  var r0=19;
  P.forEach(function(p,i){
    var rr=r0+i+1;
    var thucTe="SUMIF("+SN.pq+"!$E:$E,A"+rr+","+SN.pq+"!$J:$J)+SUMIFS("+SN.ph+"!$C:$C,"+SN.ph+"!$B:$B,A"+rr+","+SN.ph+"!$L:$L,\"Đã dùng\")";
    R[r0+i]=[{v:p.code,s:"bold"},{v:(p.tang===1?"[Tổng quan] ":"")+p.ten,s:"txt"},{v:p.donbay,s:"txt"},{v:p.moTaNgan,s:"txt"},{f:"ROUND(B12*"+(r.ns>0?p.nganSach/r.ns:0).toFixed(6)+",-3)",s:"money"},{v:Math.round(p.chiPhi),s:"money"},{v:Math.round(p.dsTang),s:"money"},{f:thucTe,s:"money"}];
  });
  var rt=r0+P.length, rtn=rt+1;
  R[rt]=[{v:"TỔNG",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{f:"SUM(E"+(r0+1)+":E"+rt+")",s:"totMoney"},{f:"SUM(F"+(r0+1)+":F"+rt+")",s:"totMoney"},{f:"SUM(G"+(r0+1)+":G"+rt+")",s:"totMoney"},{f:"SUM(H"+(r0+1)+":H"+rt+")",s:"totMoney"}];
  R[rt+2]=[{v:"HIỆU QUẢ THEO 3 MỐC (DỰ KIẾN)",s:"sec"}];
  R[rt+3]=["Mốc","Doanh số tăng (đ)","Lãi gộp (đ)","Ghi chú"].map(function(h){return {v:h,s:"head"};});
  R[rt+4]=[{v:"Trong kỳ",s:"txt"},{v:Math.round(r.dsTang),s:"money"},{v:Math.round(r.lai),s:"money"},{v:"Chi phí dự kiến sau hỗ trợ: "+vnd(r.chiPhi)+(r.chiPhiGoc>r.chiPhi?" (chưa hỗ trợ "+vnd(r.chiPhiGoc)+")":""),s:"txt"}];
  R[rt+5]=[{v:"30 ngày sau",s:"txt"},{v:Math.round(r.ds30),s:"money"},{v:Math.round(r.lai30),s:"money"},{v:"Dùng thử, phiếu, mua lại",s:"txt"}];
  R[rt+6]=[{v:"90 ngày",s:"txt"},{v:Math.round(r.ds90),s:"money"},{v:Math.round(r.lai90),s:"money"},{v:"Khách mới quay lại",s:"txt"}];
  R[rt+7]=[{v:"Lãi gộp sau chi phí (90 ngày)",s:"totTxt"},{v:"",s:"totTxt"},{v:Math.round(r.lai3),s:"totMoney"},{v:"1đ chi phí → "+r.hs3.toFixed(2).replace(".",",")+"đ lãi gộp",s:"totTxt"}];
  var rn=rt+9;
  R[rn]=[{v:"NHÓM HÀNG",s:"sec"}];
  R[rn+1]=["Nhóm hàng","Tỷ trọng doanh thu","Biên lãi gộp","Khuyến mại"].map(function(h){return {v:h,s:"head"};});
  S.nhom.forEach(function(n,i){
    R[rn+2+i]=[{v:n.ten,s:"txt"},{v:num(n.tt)/100,s:"pct"},{v:num(n.bien)/100,s:"pct"},{v:camOf(n)==="rx"?"Không — thuốc kê đơn":camOf(n)==="sua"?"Không — sữa trẻ dưới 24 tháng":"Được",s:"txt"}];
  });
  sheets.push({name:"1.TONG QUAN",cols:[44,22,16,30,30,20,22,20],rows:R,merges:["A1:H1","A2:H2"],heights:{0:26},tab:true});

  /* ---- 2. CHI TIẾT CHƯƠNG TRÌNH ---- */
  R=[]; var i2=0;
  var add=function(a,b,sa,sb){ R[i2++]=[{v:a,s:sa||"bold"},{v:b,s:sb||"txt"}]; };
  R[i2++]=[{v:"CHI TIẾT TRIỂN KHAI",s:"title"}];
  R[i2++]=[{v:"In sheet này, ký duyệt và phát cho nhân viên.",s:"note"}];
  i2++;
  P.forEach(function(p){
    R[i2++]=[{v:p.code+" · "+p.ten.toUpperCase(),s:"sec"},{v:"",s:"sec"}];
    add("Thời gian",p.thoiGian); add("Mục tiêu",p.muc); add("Đòn bẩy",p.donbay); add("Đối tượng",p.doiTuong);
    add("Cơ chế", p.bang.head.join(" | "), "bold","bold");
    p.bang.rows.forEach(function(row){ add("",row.map(stripHtml).join(" | ")); });
    p.dieuKien.forEach(function(d,j){ add(j?"":"Thể lệ","• "+d); });
    var q=(p.qua||[]).filter(function(l){return l.sl>0;});
    q.forEach(function(l,j){ add(j?"":"Quà cần chuẩn bị", l.sl+" × "+l.ten+" ("+l.tag+", "+(l.nguon==="mua"?"mua thêm":"lấy từ kho")+")"); });
    p.kichBan.forEach(function(k,j){ add(j?"":"Câu nói nhân viên", k.tinh+": "+k.noi); });
    if(p.bangTuVan) p.bangTuVan.rows.forEach(function(row,j){ add(j?"":"Gợi ý sau khi đo (DS duyệt)", row.join(" → ")); });
    (p.cpLines||[]).forEach(function(l,j){ var g=giamCua(S.hoTro,l.nhom); add(j?"":"Chi phí chi tiết", l.ten+": "+vnd(l.tien)+(g>0?" → còn "+vnd(l.tien*(1-g))+" (giảm "+pct(g,0)+" nhờ hỗ trợ)":"")); });
    if(p.pheu){ var f=p.pheu; add("Phễu dự kiến", Math.round(f.visits)+" lượt khách → "+f.luotDo+" lượt đo → "+f.donTPCN+" đơn TPCN ("+pct(f.cr,0)+") · "+f.mauN+" mẫu thử → "+f.dungMau+" khách mua · "+Math.round(f.khMoi*0.4)+" khách mới giữ lại"); }
    add("Poster", p.poster.hl+" — "+p.poster.sub);
    add("Tin Zalo", p.zalo);
    p.chuanBi.forEach(function(x,j){ add(j?"":"Chuẩn bị","• "+x); });
    p.kpi.forEach(function(k,j){ add(j?"":"Chỉ số theo dõi", k[0]+": "+k[1]); });
    add("Chi phí dự kiến", vnd(p.chiPhi)+" · doanh số tăng dự kiến "+vnd(p.dsTang));
    i2++;
  });
  if(r.matran.length){
    R[i2++]=[{v:"QUY TẮC CỘNG DỒN TRÊN CÙNG MỘT HÓA ĐƠN",s:"sec"},{v:"",s:"sec"}];
    r.matran.forEach(function(x){ add(x[0]+" + "+x[1], x[2], "txt"); });
    i2++;
  }
  R[i2++]=[{v:"GIẢI PHÁP GIẢM CHI PHÍ",s:"sec"},{v:"",s:"sec"}];
  r.giamChiPhi.filter(function(x){return x.on||x.lienQuan;}).forEach(function(x){
    add((x.on?"[Đã chọn] ":"")+x.h.ten, x.h.dk+(x.tietKiem>0?" · Giảm khoảng "+vnd(x.tietKiem):""), "bold");
    x.h.buoc.forEach(function(b){ add("", "• "+b); });
    if(x.h.mau) add("Mẫu tin nhắn", x.h.mau.replace(/\{[A-Z_]+\}/g,"[..]"));
  });
  i2++;
  R[i2++]=[{v:"LỊCH TRIỂN KHAI",s:"sec"},{v:"",s:"sec"}];
  r.lich.forEach(function(l){ add(dmyy(l[0])+" · "+l[1], l[2], "txt"); });
  i2++;
  R[i2++]=[{v:"Người duyệt: ........................   Ngày: ....../....../..........",s:"bold"}];
  sheets.push({name:"2.CHUONG TRINH",cols:[30,120],rows:R});

  /* ---- 3. KHO QUÀ ---- */
  var gom={}, orderG=[];
  P.forEach(function(p){ (p.qua||[]).forEach(function(l){
    if(l.sl<=0) return;
    if(!gom[l.ten]){ gom[l.ten]={ten:l.ten, tags:[], nguon:l.nguon, von:l.von, heSo:l.heSo, le:l.le, sl:0}; orderG.push(l.ten); }
    var g=gom[l.ten]; g.sl+=l.sl; var t=p.code+" "+l.tag; if(g.tags.indexOf(t)<0) g.tags.push(t);
  }); });
  R=[];
  R[0]=[{v:"KHO QUÀ — TỰ TRỪ KHI GHI SỔ PHÁT QUÀ",s:"title"}];
  R[1]=[{v:"Cột Đã phát lấy từ sheet 5. Hệ số chi phí: quà hãng tặng 0 · hàng cận hạn 0,4 · hàng chậm bán 0,7 · hàng thường và quà mua thêm 1.",s:"note"}];
  R[3]=["Tên quà","Dùng cho","Nguồn","Giá vốn (đ)","Hệ số chi phí","Giá trị bán lẻ (đ)","SL chuẩn bị","Đã phát","Còn lại","Tỷ lệ còn","Chi phí thực đã dùng (đ)","Trạng thái"].map(function(h){return {v:h,s:"head"};});
  var nG=orderG.length+10, k0=4;
  for(var k=0;k<nG;k++){
    var rr=k0+k+1, g=gom[orderG[k]];
    R[k0+k]=[
      g?{v:g.ten,s:"inTxt"}:{v:"",s:"inTxt"},
      g?{v:g.tags.join("; "),s:"txt"}:{v:"",s:"txt"},
      g?{v:g.nguon==="mua"?"Mua thêm":"Kho quầy",s:"txt"}:{v:"",s:"inTxt"},
      g?{v:g.von,s:"inMoney"}:{v:"",s:"inMoney"},
      g?{v:g.heSo,s:"inMoney"}:{v:"",s:"inMoney"},
      g?{v:g.le,s:"inMoney"}:{v:"",s:"inMoney"},
      g?{v:g.sl,s:"inMoney"}:{v:"",s:"inMoney"},
      {f:"IF(A"+rr+"=\"\",\"\",SUMIF("+SN.pq+"!$F:$F,A"+rr+","+SN.pq+"!$G:$G))",s:"money"},
      {f:"IF(A"+rr+"=\"\",\"\",G"+rr+"-H"+rr+")",s:"money"},
      {f:"IF(A"+rr+"=\"\",\"\",IF(N(G"+rr+")>0,I"+rr+"/G"+rr+",0))",s:"pct"},
      {f:"IF(A"+rr+"=\"\",\"\",H"+rr+"*D"+rr+"*E"+rr+")",s:"money"},
      {f:"IF(A"+rr+"=\"\",\"\",IF(I"+rr+"<=0,\"Hết quà\",IF(J"+rr+"<0.2,\"Sắp hết\",\"Đủ\")))",s:"txt"}
    ];
  }
  var kEnd=k0+nG;
  R[kEnd]=[{v:"TỔNG",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{f:"SUM(G5:G"+kEnd+")",s:"totMoney"},{f:"SUM(H5:H"+kEnd+")",s:"totMoney"},{f:"SUM(I5:I"+kEnd+")",s:"totMoney"},{v:"",s:"totTxt"},{f:"SUM(K5:K"+kEnd+")",s:"totMoney"},{v:"",s:"totTxt"}];
  var chiPhiQuaDK=Object.keys(gom).reduce(function(a,t){return a+gom[t].sl*gom[t].von*gom[t].heSo;},0);
  R[kEnd+1]=[{v:"Chi phí quà dự kiến nếu phát hết (đ)",s:"bold"},{v:Math.round(chiPhiQuaDK),s:"money"}];
  if(r.huy.length){
    R[kEnd+3]=[{v:"HÀNG DƯỚI 1 THÁNG HẠN — KHÔNG DÙNG, TRẢ NCC HOẶC HỦY",s:"sec"}];
    r.huy.forEach(function(h,j){ R[kEnd+4+j]=[{v:h.ten,s:"txt"},{v:h.sl+" đơn vị",s:"txt"}]; });
  }
  sheets.push({name:"3.KHO QUA",cols:[34,34,12,13,10,14,12,11,11,10,16,12],rows:R,freeze:4,
    cf:[{ref:"L5:L"+kEnd,rules:[{text:"Hết",dxf:0},{text:"Sắp",dxf:1},{text:"Đủ",dxf:2}]}]});

  /* ---- 4. NHẬT KÝ NGÀY ---- */
  R=[];
  var nEnd=4+c.T;
  R[0]=[{v:"NHẬT KÝ DOANH SỐ TỪNG NGÀY",s:"title"}];
  R[1]=[{v:"Cuối mỗi ngày nhập các ô vàng từ phần mềm bán hàng. Ngày tự chạy theo ngày bắt đầu ở sheet 1.",s:"note"}];
  R[3]=["Ngày","Doanh số (đ)","Số hóa đơn","Giá trị TB/HĐ (đ)","HĐ đạt mốc / điều kiện","Tỷ lệ đạt","Combo bán","Phiếu phát","Phiếu dùng","Lượt bốc thăm","Khách mới","Thành viên mới","Chi phí quà (đ)","Tăng so với trước","Lãi gộp tăng ước tính (đ)","Ghi chú"].map(function(h){return {v:h,s:"head"};});
  for(var d=0; d<c.T; d++){
    var q2=5+d;
    R[4+d]=[
      d===0?{f:SN.tq+"!B9",s:"date"}:{f:"A"+(q2-1)+"+1",s:"date"},
      {v:"",s:"inMoney"},{v:"",s:"inMoney"},
      {f:"IF(N(C"+q2+")>0,B"+q2+"/C"+q2+",\"\")",s:"money"},
      {v:"",s:"inMoney"},
      {f:"IF(N(C"+q2+")>0,E"+q2+"/C"+q2+",\"\")",s:"pct"},
      {v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},
      {f:"SUMIF("+SN.pq+"!$A:$A,A"+q2+","+SN.pq+"!$J:$J)",s:"money"},
      {f:"IF(N(B"+q2+")=0,\"\",B"+q2+"/"+SN.tq+"!$B$5-1)",s:"pct"},
      {f:"IF(N(B"+q2+")=0,\"\",(B"+q2+"-"+SN.tq+"!$B$5)*"+SN.tq+"!$B$8-M"+q2+")",s:"money"},
      {v:"",s:"inTxt"}
    ];
  }
  var sumCols=["B","C","E","G","H","I","J","K","L","M","O"];
  var tot=[{v:"TỔNG",s:"totTxt"}];
  for(var cc=1;cc<16;cc++){
    var L2=XL.col(cc);
    if(sumCols.indexOf(L2)>=0) tot.push({f:"SUM("+L2+"5:"+L2+nEnd+")",s:"totMoney"});
    else if(L2==="D") tot.push({f:"IF(N(C"+(nEnd+1)+")>0,B"+(nEnd+1)+"/C"+(nEnd+1)+",0)",s:"totMoney"});
    else if(L2==="F") tot.push({f:"IF(N(C"+(nEnd+1)+")>0,E"+(nEnd+1)+"/C"+(nEnd+1)+",0)",s:"totPct"});
    else if(L2==="N") tot.push({f:"IF(COUNT(B5:B"+nEnd+")>0,AVERAGE(B5:B"+nEnd+")/"+SN.tq+"!$B$5-1,0)",s:"totPct"});
    else tot.push({v:"",s:"totTxt"});
  }
  R[nEnd]=tot;
  sheets.push({name:"4.NHAT KY NGAY",cols:[12,14,10,13,12,9,9,9,9,10,9,11,13,11,15,24],rows:R,freeze:4});

  /* ---- 5. PHÁT QUÀ ---- */
  R=[];
  R[0]=[{v:"SỔ PHÁT QUÀ VÀ TRÚNG THƯỞNG",s:"title"}];
  R[1]=[{v:"Mỗi lần phát quà ghi một dòng. Tên quà chọn từ danh sách để kho tự trừ. Đây cũng là danh sách khách để chăm sóc sau chương trình.",s:"note"}];
  R[3]=["Ngày","Tên khách","Số điện thoại","Số hóa đơn","Mã CT","Quà","Số lượng","Giá vốn (đ)","Hệ số","Chi phí (đ)","Nhân viên","Mốc / giải"].map(function(h){return {v:h,s:"head"};});
  var nPQ=400;
  for(var j=0;j<nPQ;j++){
    var q3=5+j;
    R[4+j]=[{v:"",s:"inDate"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inMoney"},
      {f:"IF(F"+q3+"=\"\",\"\",IFERROR(VLOOKUP(F"+q3+","+SN.kho+"!$A$5:$E$"+kEnd+",4,0),0))",s:"money"},
      {f:"IF(F"+q3+"=\"\",\"\",IFERROR(VLOOKUP(F"+q3+","+SN.kho+"!$A$5:$E$"+kEnd+",5,0),1))",s:"money"},
      {f:"IF(F"+q3+"=\"\",\"\",N(G"+q3+")*H"+q3+"*I"+q3+")",s:"money"},
      {v:"",s:"inTxt"},{v:"",s:"inTxt"}];
  }
  sheets.push({name:"5.PHAT QUA",cols:[12,22,14,12,9,30,9,12,8,12,14,16],rows:R,freeze:4,
    dv:[{ref:"E5:E"+(4+nPQ),f:'"'+P.map(function(p){return p.code;}).join(",")+'"'},{ref:"F5:F"+(4+nPQ),f:SN.kho+"!$A$5:$A$"+kEnd}]});

  /* ---- 6. PHIẾU ---- */
  var phieu=[];
  P.forEach(function(p){
    if(p.id==="voucher") phieu.push({ma:"VC",ct:p.code,gt:p.V,min:p.Y,han:p.han,n:Math.min(600,Math.ceil(p.phat*1.2))});
    if(p.id==="gioithieu") phieu.push({ma:"GT",ct:p.code,gt:p.R,min:0,han:30,n:Math.min(200,Math.ceil((p.dsTang/c.A/2.2)*1.5))});
    if(p.id==="khaitruong" && !c.has("voucher")) phieu.push({ma:"KT",ct:p.code,gt:nice5k(c.A*0.1),min:niceUp(c.A*1.5),han:30,n:Math.min(400,Math.round(c.N*3*0.8))});
    if(p.id==="trian" && !c.has("tichdiem")) phieu.push({ma:"TA",ct:p.code,gt:nice5k(c.A*0.1),min:niceUp(c.A*1.3),han:30,n:Math.min(400,Math.round(c.N*c.T*0.25))});
    if(p.id==="boctham") phieu.push({ma:"BT",ct:p.code,gt:5000,min:niceUp(c.A),han:30,n:p.cauTruc[3]*p.hop});
  });
  R=[];
  R[0]=[{v:"DANH SÁCH MÃ PHIẾU MUA HÀNG",s:"title"}];
  R[1]=[{v:"Đã phát",s:"bold"},{f:"COUNT(E5:E3000)",s:"money"},{v:"Đã dùng",s:"bold"},{f:"COUNTIF(L5:L3000,\"Đã dùng\")",s:"money"},{v:"Tỷ lệ dùng",s:"bold"},{f:"IF(B2>0,D2/B2,0)",s:"pct"},{v:"Tiền phiếu đã dùng (đ)",s:"bold"},{f:"SUMIF(L5:L3000,\"Đã dùng\",C5:C3000)",s:"money"}];
  R[2]=[{v:"Khi phát phiếu: nhập ngày phát, tên, SĐT. Khi khách dùng: nhập ngày dùng, số hóa đơn. Hạn dùng và trạng thái tự tính.",s:"note"}];
  R[3]=["Mã phiếu","Mã CT","Giá trị (đ)","Hóa đơn tối thiểu (đ)","Ngày phát","Hạn dùng","Tên khách","Số điện thoại","Ngày dùng","Số HĐ dùng","Giá trị HĐ dùng (đ)","Trạng thái","Số ngày hiệu lực"].map(function(h){return {v:h,s:"head"};});
  var rowP=4;
  if(!phieu.length) phieu.push({ma:"PH",ct:"",gt:0,min:0,han:14,n:30});
  phieu.forEach(function(ph){
    for(var t=1;t<=ph.n;t++){
      var q4=rowP+1;
      R[rowP]=[{v:ph.ma+"-"+String(t).padStart(4,"0"),s:"bold"},{v:ph.ct,s:"txt"},{v:ph.gt||"",s:"inMoney"},{v:ph.min||"",s:"inMoney"},{v:"",s:"inDate"},
        {f:"IF(E"+q4+"=\"\",\"\",E"+q4+"+M"+q4+")",s:"date"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inDate"},{v:"",s:"inTxt"},{v:"",s:"inMoney"},
        {f:"IF(E"+q4+"=\"\",\"Chưa phát\",IF(I"+q4+"<>\"\",\"Đã dùng\",IF(TODAY()>F"+q4+",\"Hết hạn\",\"Còn hạn\")))",s:"txt"},{v:ph.han,s:"inMoney"}];
      rowP++;
    }
  });
  sheets.push({name:"6.PHIEU",cols:[12,8,11,14,12,12,20,14,12,12,14,12,10],rows:R,freeze:4,
    cf:[{ref:"L5:L"+rowP,rules:[{text:"Hết hạn",dxf:0},{text:"Còn hạn",dxf:1},{text:"Đã dùng",dxf:2}]}]});

  /* ---- 7. THÀNH VIÊN ---- */
  var td=P.filter(function(p){return p.id==="tichdiem";})[0];
  R=[];
  R[0]=[{v:"SỔ THÀNH VIÊN TÍCH ĐIỂM",s:"title"}];
  R[1]=[{v:"Số tiền cho 1 điểm (đ)",s:"bold"},{v:10000,s:"inMoney"},null,{v:"Giá trị phiếu cho 100 điểm (đ)",s:"bold"},{v:td?td.V100:Math.round(1e6*clamp(c.bKM*0.08,0.01,0.025)/1000)*1000,s:"inMoney"}];
  R[2]=[{v:"Ngưỡng hạng Bạc (chi tiêu 6 tháng, đ)",s:"bold"},{v:td?td.bac:niceUp(c.A*12),s:"inMoney"},null,{v:"Ngưỡng hạng Vàng (đ)",s:"bold"},{v:td?td.vang:niceUp(c.A*35),s:"inMoney"}];
  R[3]=[{v:"Hệ số điểm: Thành viên 1,0 · Bạc 1,2 · Vàng 1,5. Cột Sinh nhật tháng này dùng để gửi quà sinh nhật; lọc cột Chi tiêu giảm dần để lấy danh sách khách tri ân.",s:"note"}];
  R[4]=["Mã TV","Tên khách","Số điện thoại","Ngày sinh","Ngày đăng ký","Chi tiêu 6 tháng (đ)","Hạng","Hệ số","Điểm thưởng đăng ký","Điểm tích","Điểm đã đổi","Điểm còn","Quy ra tiền (đ)","Sinh nhật tháng này"].map(function(h){return {v:h,s:"head"};});
  for(var m2=0;m2<300;m2++){
    var q5=6+m2;
    R[5+m2]=[{v:"TV-"+String(m2+1).padStart(4,"0"),s:"bold"},{v:"",s:"inTxt"},{v:"",s:"inTxt"},{v:"",s:"inDate"},{v:"",s:"inDate"},{v:"",s:"inMoney"},
      {f:"IF(F"+q5+"=\"\",\"\",IF(F"+q5+">=$E$3,\"Vàng\",IF(F"+q5+">=$B$3,\"Bạc\",\"Thành viên\")))",s:"txt"},
      {f:"IF(G"+q5+"=\"\",\"\",IF(G"+q5+"=\"Vàng\",1.5,IF(G"+q5+"=\"Bạc\",1.2,1)))",s:"money"},
      {v:"",s:"inMoney"},
      {f:"IF(F"+q5+"=\"\",\"\",INT(F"+q5+"/$B$2*H"+q5+")+N(I"+q5+"))",s:"money"},
      {v:"",s:"inMoney"},
      {f:"IF(J"+q5+"=\"\",\"\",J"+q5+"-N(K"+q5+"))",s:"money"},
      {f:"IF(L"+q5+"=\"\",\"\",INT(L"+q5+"/100)*$E$2)",s:"money"},
      {f:"IF(D"+q5+"=\"\",\"\",IF(MONTH(D"+q5+")=MONTH(TODAY()),\"Có\",\"\"))",s:"txt"}];
  }
  sheets.push({name:"7.THANH VIEN",cols:[10,22,14,12,12,16,11,8,11,10,11,10,13,12],rows:R,freeze:5,
    cf:[{ref:"G6:G305",rules:[{text:"Vàng",dxf:1},{text:"Bạc",dxf:2}]}]});

  /* ---- 8. NGHIỆM THU ---- */
  R=[];
  var NK=SN.nk, TQ=SN.tq, rB="!$B$5:$B$"+nEnd, rC="!$C$5:$C$"+nEnd;
  R[0]=[{v:"NGHIỆM THU CHƯƠNG TRÌNH",s:"title"}];
  R[1]=[{v:"Tự tính từ sheet 4, 5, 6. Mở sau khi kết thúc chương trình 3 ngày.",s:"note"}];
  R[3]=["Chỉ tiêu","Trước chương trình","Kế hoạch","Thực tế","Thực tế / kế hoạch"].map(function(h){return {v:h,s:"head"};});
  var hs=function(rw){ return {f:"IF(N(C"+rw+")>0,D"+rw+"/C"+rw+",0)",s:"pct"}; };
  R[4]=[{v:"Doanh số trung bình/ngày (đ)",s:"txt"},{f:TQ+"!B5",s:"money"},{f:"B5*(1+"+TQ+"!B13)",s:"money"},{f:"IFERROR(AVERAGE("+NK+rB+"),0)",s:"money"},hs(5)];
  R[5]=[{v:"Số hóa đơn trung bình/ngày",s:"txt"},{f:TQ+"!B7",s:"money"},{f:"B6*1.05",s:"money"},{f:"IFERROR(AVERAGE("+NK+rC+"),0)",s:"money"},hs(6)];
  R[6]=[{v:"Giá trị trung bình 1 hóa đơn (đ)",s:"txt"},{f:TQ+"!B6",s:"money"},{f:"B7*1.1",s:"money"},{f:"IF(SUM("+NK+rC+")>0,SUM("+NK+rB+")/SUM("+NK+rC+"),0)",s:"money"},hs(7)];
  R[7]=[{v:"Doanh số các ngày đã ghi (đ)",s:"txt"},{f:"B5*COUNT("+NK+rB+")",s:"money"},{f:"C5*COUNT("+NK+rB+")",s:"money"},{f:"SUM("+NK+rB+")",s:"money"},hs(8)];
  R[8]=[{v:"Doanh số tăng thêm (đ)",s:"txt"},{v:0,s:"money"},{f:"C8-B8",s:"money"},{f:"D8-B8",s:"money"},hs(9)];
  R[9]=[{v:"Chi phí quà (đ)",s:"txt"},{v:"",s:"txt"},{f:TQ+"!F"+rtn+"*IF("+TQ+"!B10>0,COUNT("+NK+rB+")/"+TQ+"!B10,0)",s:"money"},{f:"SUM("+SN.pq+"!$J$5:$J$"+(4+nPQ)+")",s:"money"},{v:"",s:"txt"}];
  R[10]=[{v:"Chi phí phiếu đã dùng (đ)",s:"txt"},{v:"",s:"txt"},{v:"",s:"txt"},{f:SN.ph+"!H2",s:"money"},{v:"",s:"txt"}];
  R[11]=[{v:"Tổng chi phí (đ)",s:"bold"},{v:"",s:"txt"},{f:"C10",s:"money"},{f:"D10+D11",s:"money"},hs(12)];
  R[12]=[{v:"Lãi gộp tăng thêm sau chi phí (đ)",s:"bold"},{v:"",s:"txt"},{f:"C9*"+TQ+"!B8-C12",s:"money"},{f:"D9*"+TQ+"!B8-D12",s:"money"},{v:"",s:"txt"}];
  R[13]=[{v:"Lãi gộp tạo ra trên 1đ chi phí",s:"bold"},{v:"",s:"txt"},{f:"IF(C12>0,C9*"+TQ+"!B8/C12,0)",s:"money"},{f:"IF(D12>0,D9*"+TQ+"!B8/D12,0)",s:"money"},{v:"",s:"txt"}];
  R[14]=[{v:"Khách mới",s:"txt"},{v:"",s:"txt"},{v:"",s:"inMoney"},{f:"SUM("+NK+"!$K$5:$K$"+nEnd+")",s:"money"},hs(15)];
  R[15]=[{v:"Thành viên mới",s:"txt"},{v:"",s:"txt"},{v:"",s:"inMoney"},{f:"SUM("+NK+"!$L$5:$L$"+nEnd+")",s:"money"},hs(16)];
  R[16]=[{v:"Tỷ lệ phiếu được dùng",s:"txt"},{v:"",s:"txt"},{v:c.zalo?0.4:0.28,s:"inPct"},{f:SN.ph+"!F2",s:"pct"},hs(17)];
  R[18]=[{v:"KẾT LUẬN",s:"sec"},{f:"IF(COUNT("+NK+rB+")=0,\"Chưa có số liệu — nhập sheet 4 trước\",IF(D14>=1.5,IF(E5>=0.95,\"GIỮ — lặp lại kỳ sau, đổi quà để khách không nhàm\",\"GIỮ, TĂNG TRUYỀN THÔNG — hiệu quả chi phí tốt nhưng doanh số chưa tới kế hoạch\"),IF(D14>=1,\"CHỈNH — cắt chương trình tốn kém nhất, thay bằng quà hãng tặng\",IF(D12=0,\"CHƯA GHI CHI PHÍ — kiểm tra sheet 5 và 6\",\"DỪNG — chi phí lớn hơn phần lãi tạo ra\"))))",s:"bold"}];
  R[20]=[{v:"TỪNG CHƯƠNG TRÌNH",s:"sec"}];
  R[21]=["Mã · chương trình","Chi phí dự kiến cả kỳ (đ)","Chi phí thực tế (đ)","Thực tế / dự kiến","Nhận xét của chủ quầy"].map(function(h){return {v:h,s:"head"};});
  P.forEach(function(p,i){
    var q6=23+i, src=r0+i+1;
    R[22+i]=[{v:p.code+" · "+p.ten,s:"txt"},{f:TQ+"!F"+src,s:"money"},{f:TQ+"!H"+src,s:"money"},{f:"IF(N(B"+q6+")>0,C"+q6+"/B"+q6+",0)",s:"pct"},{v:"",s:"inTxt"}];
  });
  sheets.push({name:"8.NGHIEM THU",cols:[38,22,18,18,40],rows:R,merges:["B19:E19"],
    cf:[{ref:"B19",rules:[{text:"DỪNG",dxf:0},{text:"CHỈNH",dxf:1},{text:"GIỮ",dxf:2}]}]});

  /* ---- 9. PHỄU SỨC KHỎE ---- */
  R=[];
  var ev=r.ev, f=ev&&ev.pheu;
  var soNgay9=Math.max(c.evDays||0, 1), e9=4+soNgay9;
  R[0]=[{v:"PHỄU SỨC KHỎE — KHÁCH VÀO → ĐO → TƯ VẤN → MUA TPCN",s:"title"}];
  R[1]=[{v:"Ghi mỗi ngày cao điểm. Cột tỷ lệ tự tính. Dòng KẾ HOẠCH là con số tool dự kiến để so sánh.",s:"note"}];
  R[3]=["Ngày","Lượt khách","Lượt đo","Lượt tư vấn","Đơn TPCN","Doanh số TPCN (đ)","Mẫu phát","Để lại SĐT/Zalo","Tỷ lệ đo / khách","Tỷ lệ mua / đo","Giá trị đơn TPCN (đ)","Ghi chú (hãng, người trực)"].map(function(x){return {v:x,s:"head"};});
  for(var d9=0; d9<soNgay9; d9++){
    var q9=5+d9;
    R[4+d9]=[d9===0?{f:SN.tq+"!B9",s:"date"}:{f:"A"+(q9-1)+"+1",s:"date"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},{v:"",s:"inMoney"},
      {f:"IF(N(B"+q9+")>0,C"+q9+"/B"+q9+",\"\")",s:"pct"},{f:"IF(N(C"+q9+")>0,E"+q9+"/C"+q9+",\"\")",s:"pct"},{f:"IF(N(E"+q9+")>0,F"+q9+"/E"+q9+",\"\")",s:"money"},{v:"",s:"inTxt"}];
  }
  R[e9]=[{v:"THỰC TẾ",s:"totTxt"},{f:"SUM(B5:B"+e9+")",s:"totMoney"},{f:"SUM(C5:C"+e9+")",s:"totMoney"},{f:"SUM(D5:D"+e9+")",s:"totMoney"},{f:"SUM(E5:E"+e9+")",s:"totMoney"},{f:"SUM(F5:F"+e9+")",s:"totMoney"},{f:"SUM(G5:G"+e9+")",s:"totMoney"},{f:"SUM(H5:H"+e9+")",s:"totMoney"},
    {f:"IF(B"+(e9+1)+">0,C"+(e9+1)+"/B"+(e9+1)+",0)",s:"totPct"},{f:"IF(C"+(e9+1)+">0,E"+(e9+1)+"/C"+(e9+1)+",0)",s:"totPct"},{f:"IF(E"+(e9+1)+">0,F"+(e9+1)+"/E"+(e9+1)+",0)",s:"totMoney"},{v:"",s:"totTxt"}];
  R[e9+1]=[{v:"KẾ HOẠCH",s:"bold"},{v:f?Math.round(f.visits):"",s:"money"},{v:f?f.luotDo:"",s:"money"},{v:f?f.luotDo:"",s:"money"},{v:f?f.donTPCN:"",s:"money"},{v:f?Math.round(f.donTPCN*c.giaTPCN):"",s:"money"},{v:f?f.mauN:"",s:"money"},{v:f?Math.round(f.luotDo*0.6):"",s:"money"},
    {f:"IF(N(B"+(e9+2)+")>0,C"+(e9+2)+"/B"+(e9+2)+",0)",s:"pct"},{v:f?f.cr:"",s:"pct"},{v:c.giaTPCN,s:"money"},{v:ev?"Tool dự kiến":"Chưa chọn chương trình tổng quan",s:"txt"}];
  R[e9+2]=[{v:"Đạt / kế hoạch",s:"bold"},{f:"IF(N(B"+(e9+2)+")>0,B"+(e9+1)+"/B"+(e9+2)+",0)",s:"pct"},{f:"IF(N(C"+(e9+2)+")>0,C"+(e9+1)+"/C"+(e9+2)+",0)",s:"pct"},{v:"",s:"txt"},{f:"IF(N(E"+(e9+2)+")>0,E"+(e9+1)+"/E"+(e9+2)+",0)",s:"pct"},{f:"IF(N(F"+(e9+2)+")>0,F"+(e9+1)+"/F"+(e9+2)+",0)",s:"pct"}];
  R[e9+4]=[{v:"SAU SỰ KIỆN — KHÁCH MUA SAU DÙNG THỬ VÀ KHÁCH QUAY LẠI",s:"sec"}];
  R[e9+5]=["Chỉ tiêu","Kế hoạch","Thực tế","Đạt"].map(function(x){return {v:x,s:"head"};});
  var sau=[["Khách mua sau dùng thử (14 ngày)", f?f.dungMau:""],["Khách mới quay lại trong 90 ngày", f?Math.round(f.khMoi*0.4):""],["Doanh số 30 ngày sau (đ)", Math.round(r.ds30)],["Doanh số khách mới 90 ngày (đ)", Math.round(r.ds90)]];
  sau.forEach(function(x,j){ var q=e9+7+j; R[e9+6+j]=[{v:x[0],s:"txt"},{v:x[1],s:"money"},{v:"",s:"inMoney"},{f:"IF(N(B"+q+")>0,C"+q+"/B"+q+",0)",s:"pct"}]; });
  sheets.push({name:"9.PHEU SUC KHOE",cols:[34,12,10,11,10,16,10,14,13,12,16,28],rows:R,freeze:4});

  /* ---- 10. GIẢM CHI PHÍ ---- */
  R=[];
  R[0]=[{v:"KẾ HOẠCH XIN HỖ TRỢ, GIẢM CHI PHÍ",s:"title"}];
  R[1]=[{v:"Theo dõi từng việc: ai phụ trách, hạn liên hệ, kết quả. Cột Tiết kiệm thực tế nhập sau khi chốt.",s:"note"}];
  R[3]=["Giải pháp","Điều kiện","Tiết kiệm dự kiến (đ)","Người phụ trách","Hạn liên hệ","Đơn vị / người liên hệ","Kết quả","Tiết kiệm thực tế (đ)"].map(function(x){return {v:x,s:"head"};});
  var list10=r.giamChiPhi.filter(function(x){return x.on||x.lienQuan;});
  var hanOf={hang_ban:-21,hang_qua:-21,hang_ck:-21,hang_posm:-21,phuong:-14,hoi:-14,sinhvien:-21,zalo_kv:-3,chung:-14,tuin:-10,chophien:-30};
  list10.forEach(function(x,j){
    R[4+j]=[{v:(x.on?"[Đã chọn] ":"")+x.h.ten,s:"bold"},{v:x.h.dk,s:"txt"},{v:Math.max(0,Math.round(x.tietKiem)),s:"money"},{v:"",s:"inTxt"},{v:serial(addDays(c.from,hanOf[x.h.id]||-14)),s:"inDate"},{v:"",s:"inTxt"},{v:"Chưa liên hệ",s:"inTxt"},{v:"",s:"inMoney"}];
  });
  var e10=4+list10.length;
  R[e10]=[{v:"CỘNG (ước tính từng giải pháp, không cộng dồn tuyệt đối)",s:"totTxt"},{v:"",s:"totTxt"},{f:"SUM(C5:C"+e10+")",s:"totMoney"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{v:"",s:"totTxt"},{f:"SUM(H5:H"+e10+")",s:"totMoney"}];
  R[e10+1]=[{v:"Chi phí chưa có hỗ trợ (đ)",s:"bold"},{v:"",s:"txt"},{v:Math.round(r.chiPhiGoc),s:"money"}];
  R[e10+2]=[{v:"Chi phí sau các hỗ trợ đã chọn (đ)",s:"bold"},{v:"",s:"txt"},{v:Math.round(r.chiPhi),s:"money"}];
  R[e10+4]=[{v:"Gợi ý giá trị Kết quả: Chưa liên hệ · Đang chờ · Đồng ý · Từ chối",s:"note"}];
  sheets.push({name:"10.GIAM CHI PHI",cols:[42,50,16,16,13,24,14,16],rows:R,freeze:4,
    dv:list10.length?[{ref:"G5:G"+e10,f:'"Chưa liên hệ,Đang chờ,Đồng ý,Từ chối"'}]:[],
    cf:list10.length?[{ref:"G5:G"+e10,rules:[{text:"Từ chối",dxf:0},{text:"Đang chờ",dxf:1},{text:"Đồng ý",dxf:2}]}]:[]});

  return XL.build(sheets);
}

/* Helper xuất file Excel và tự kích hoạt download trên trình duyệt */
export function downloadCampaignExcel(lastRes, storeName = "") {
  if (!lastRes) return false;
  const bytes = taoWorkbook(lastRes, storeName);
  if (!bytes) return false;
  const name = `chuong-trinh-ban-hang-${lastRes.S?.batDau || "thethao"}.xlsx`;
  const blob = new Blob([bytes], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  setTimeout(() => {
    URL.revokeObjectURL(url);
    a.remove();
  }, 1500);
  return true;
}
